import {
    isScm,
    isCluster,
    isCustomer,
    isCustomerAdmin,
    isCustomerUser,
    isFe,
    isSp,
    isPsp,
    isIsp,
    isSuperVisor,
    SCM,
    SUPERVISOR,
    CUSTOMER,
    CUSTOMER_ADMIN,
    CUSTOMER_USER,
    isSpIsp,
    isCustomerGroup,
} from '../../utils/role';
import UpdateRmaDetails from './Modal/UpdateRmaDetails';
import { canBulkRemoveCluster, canLogOfflineTransactions, canManageOtherOrgs, canUnlockSignOff, canViewNewTicketTab, canViewTodayStatusTab, isApprovePaymentAllowed, isAssignAllowed, isCreateTicketAllowed, isDownloadOfflineTransactionAllowed, isSignOffApproveAllowed, isTicketAdditionAllowed, isViewPoAllowed } from '../../utils/access';
import DownloadCsv from './Modal/DownloadCsv';
import { closeModalAction, openCustomModal, openFullscreenModal, openTextModalAction } from '../../actions/modal';
import {
    cloneTickets,
    deleteTicketsRequest,
    emailReport,
    getAssetConfigTemplate,
    getTicketReportLink,
    requestTrackFE,
    siteCompleted,
    updateDocketDetails,
    bulkHardCopyRecievedUpdate
} from '../../actions/tickets';
import { updateSignOffSteps } from '../../actions/ticketExecution';
import ShareFeasibilityLink from '../team/Modals/ShareFeasibilityLink';
import AssignTechSupport from './Modal/AssignTechSupport';
import BulkEditExecutionDate from './Modal/BulkEditExecutionDate';
import AddNewPincode from './Modal/AddNewPincode';
import { sendToastMessage } from '../../actions/toast';
import AssignSP from './Modal/AssignSP';
import moment from 'moment';
import config from '../../config';
import { downloadCustomerReport } from '../../actions/conversations';
import prodConfig from '../../config/env/production';
import UpdateSignOffNotes from './Modal/updateSignOffNote';
import { RenderRemark } from './TicketColumns/Progress';
import RaisePo from '../raise-po';
import { OrgTypes, ScogoID, validateDateValue, validateStringValue } from '../../utils/common';
import PoApproval from './PoApproval';
import CloseFeasibility from './CloseFeasibility';
import HardCloseTicket from './Modal/HardCloseTicket';
import { openTicketPaymentModal } from './TicketColumns/Price';
import { withdrawTicket } from '../../actions/ticketAssignment';
import UpdateTicketDate from './Modal/UpdateTicketDate';
import { FeRating } from '../Payments/Modals/FeRating';
import CreateAppointment from './TicketColumns/CreateAppointment';
import { UnlockSignoff } from './Modal/UnlockSignoff';
import RenderUpdatePo from '../Payments/Modals/RenderUpdatePo';
import BulkUploadOfflineTransaction from './Modal/BulkOfflineTransaction';
import devConfig from '../../config/env/development';
import NotifyTicketDetailsToEndCustomer from './Modal/NotifyTicketDetailsToEndCustomer';
import React from 'react';
import AssignTicketOwnerShip from './Modal/AssignTicketOwnerShip';
import { bulkCloneServiceRequest, bulkDeleteServiceRequest, bulkServiceRequestStateChange, cloneServiceRequest, deleteServiceRequest, holdOrResumeServiceRequest, releaseVendor, removeBulkAgent, siteCompleteTicketMilestone } from '../../actions/service_request';
import BillingApproval, { RevokeBillingApproval } from '../CustomerBilling/Modals/BillingApproval';
import { BillingStatus, getTicketBillingStatus, isCustomerBillingPending, maxTicketsPerBillingApproval } from '../CustomerBilling/CustomerBillingController';
import SiteComplete from './Modal/SiteComplete';
import ExecutionDate from './Modal/ExecutionDate';
import MapFaultyAsset from './Modal/MapFaultyAsset';
import BulkUploadModal from './Modal/BulkUploadModal';
import { get } from 'lodash';
import Assign from './Modal/Assign';
import ReleaseTicket from './Modal/ReleaseTicket';
import AddMilestoneInServiceRequest from './Modal/AddMilestoneInServiceRequest';
import ViewAssetConfig, { assetConfigModalSize } from './Modal/ViewAssetConfig';
import { RemarkForm } from '../Payments/Modals/EditPayout/EditPayoutTable';
import { isMobileView, ReportsName } from '../../utils/utils';
import RequestStatement from '../Wallet/Modals/RequestStatement';
import RejectSignOff from './Modal/RejectSignOff';
import CustomerApproveRejectSignOff from './Modal/CustomerApproveRejectSignOff';
import RaisePavSignOff from './Modal/RaisePavSignOff';
import { canRaisePavMilestoneSignOff, canVerifyPavAssets, isPavMilestone, isPavMilestoneSignOffUnlocked } from '../../features/pav/pavConfig';
import PavPhysicalVerification from '../../features/pav/PavPhysicalVerification';

const ticketChat = 'ticketChat';

export const allTab = {
    label: 'All',
    id: 'all_tickets',
    path: 'all_tickets',
};

export const todayStatus = {
    label: 'Today Status',
    id: 'today_status',
    path: 'today_status',
};

export const newAndCustomerTab = {
    label: 'New',
    id: 'new',
    path: 'new',
};

export const triggerTab = {
    label: 'Trigger',
    id: 'triggered',
    path: 'triggered',
};
export const plannedTab = {
    label: 'Planned',
    id: 'planned',
    path: 'planned',
};
export const ongoingTab = {
    label: 'Ongoing',
    id: 'ongoing',
    path: 'ongoing',
};

export const IssuesTab = {
    label: 'Issues',
    id: 'escalated',
    path: 'escalated',
};

export const completedTab = {
    label: 'Completed',
    id: 'sitecomplete',
    path: 'sitecomplete',
};

export const closedTab = {
    label: 'Closed',
    id: 'closed',
    path: 'closed',
};

export const scheduledTab = {
    label: 'Scheduled',
    id: 'scheduled',
    path: 'scheduled',
};

export const newMainTab = {
    label: 'New Tickets',
    id: 'new_tickets',
    path: 'new_tickets',
    icon: 'confirmation_number',
    getSubTabs: () => [],
};

export const acceptedMainTicketsTab = {
    label: 'Accepted Tickets',
    id: 'accepted',
    path: 'accepted',
    icon: 'confirmation_number',
    getSubTabs: (role, type) => {
        let tabs = [];
        if (isSp(role, type) || isIsp(role, type) || isSpIsp(role, type)) {
            tabs = [allTab, ongoingTab, IssuesTab, completedTab];
        }
        return tabs;
    },
};

const getTabFromQueryString = ({ tabs, queryKey, query }) => {
    const match = query.get(queryKey);
    let queryTab;
    if (match) queryTab = match;
    return tabs.find((tab) => tab.path === queryTab);
};

export const getTicketDefaultTab = ({ query, actions, is_possible_remote_support }) => {
    const tabs = getTicketTabs(actions, { is_possible_remote_support });
    let tab = tabs[0];
    if (query) {
        const matchingMainTab = getTabFromQueryString({ tabs: tabs, queryKey: 'tab', query });
        if (matchingMainTab) tab = matchingMainTab;
    }
    return tab?.path;
};

export const getTicketTabs = (actions = [], { is_possible_remote_support } = {}) => {
    let tabs = [newMainTab, todayStatus, allTab];
    if (is_possible_remote_support) tabs = [allTab, newMainTab, todayStatus];
    tabs = tabs.filter((tab) => {
        if (tab.id === todayStatus.id) {
            return canViewTodayStatusTab(actions);
        }
        if (tab.id === newMainTab.id) {
            return canViewNewTicketTab(actions);
        }

        return tab;
    });
    return tabs;
};

export const getTicketSubTabs = () => {
    return [newMainTab, todayStatus, allTab];
};

export const defaultRowsPerPage = 10;
export const defaultPage = 1;

export const scogoEvent = {
    ticketClosedByNoc: 15,
    siteNotCompleted: 56,
    reachedSite: 10,
    feNotReachedSite: 55,
    goingToSite: 66,
};
export const ticketExtraColumns = {
    price: 'Price',
    contact_details: 'Contact Details',
    partner_details: 'Partner Details',
    current_stataus: 'Current Status',
    description: 'Description',
    progress: 'Progress',
    assets: 'Assets',
    remark: 'Remark',
    shipping_details: 'Shipping Details',
};


export const AttributeKeys = {
    issue_category: 'issue_category',
    sow: 'sow',
    required_tools: 'required_tools',
    signoff_sample: 'signoff_sample',
    ticket_owners: 'ticket_owners'
};

export const showHideColumnsOption = [
    ticketExtraColumns.price,
    ticketExtraColumns.contact_details,
    ticketExtraColumns.partner_details,
    ticketExtraColumns.current_stataus,
    ticketExtraColumns.description,
    ticketExtraColumns.progress,
    ticketExtraColumns.assets,
    ticketExtraColumns.remark,
    ticketExtraColumns.shipping_details,
];

export const columnsKeys = {
    order_date: 'order_date',
    ticket_id: 'ticket_id',
    customer_details: 'customer_details',
    site_details: 'site_details',
    ticket_description: 'ticket_description',
    price: 'price',
    contact_details: 'contact_details',
    partner_details: 'partner_details',
    current_status: 'current_status',
    progress: 'progress',
    assets: 'assets',
    remark: 'remark',
    shipping_details: 'shipping_details',
    action: 'action',
    time: 'time',
    going_to_site: 'going_to_site',
    reached_site: 'reached_site',
    site_complete: 'site_complete',
};

export const serviceTypeIds = {
    migration: 11,
    reconcile: 12,
    feasibility: 13,
    release_asset: 14,
    scrap_asset: 15,
    asset_replace: 16,
    reverse_logistics: 4,
    support: 5,
};

export const ticketTypes = {
    field: 0,
    rma: 1, // doesn't actually get used, rma tickets are checked with is_rma_raised = 1
    support: 2,
};

export const ticketStatusList = [
    {
        label: 'Sign Off Accepted',
        tag: 'sign_off_accepted',
        labelClass: 'bg-labelLightGreen font-medium py-1',
        shownNobgLabel: true,
        color: 'scogo2e',
        check: ({ signOffAccept, signOffRequest, signOffReject, is_deleted, isOnHold, isEscalated, hardClose }) =>
            signOffAccept === 1 && signOffRequest === 1 && signOffReject === 0 && is_deleted === 0 && isOnHold === 0 && isEscalated === 0 && hardClose === 0,
    },
    {
        key: 'new',
        label: 'New',
        tag: 'new',
        color: 'scogo2e',
        check: (
            {
                fk_assigned_primary_sp_id,
                requestRaised,
                closedByNoc,
                is_deleted,
                hardClose,
                accepted_sp_id,
                reachedSite,
                accepted_fe_id,
                assignToScogo,
                ticket_owned_by,
                isOnHold,
                isEscalated,
                signOffReject,
            },
            { role, type }
        ) => {
            let baseCondition = isOnHold === 0 && isEscalated === 0 && signOffReject === 0;
            if (isSp(role, type) || isCluster(role, type) || isSuperVisor(role, type) || isPsp(role, type)) {
                return accepted_sp_id === 0 && requestRaised === 1 && closedByNoc === 0 && is_deleted === 0 && hardClose === 0 && reachedSite === 0 && baseCondition;
            } else if (isFe(role, type)) {
                return accepted_fe_id !== 0 && requestRaised === 1 && closedByNoc === 0 && is_deleted === 0 && hardClose === 0 && reachedSite === 0 && baseCondition;
            } else if (isCustomerGroup(role, type)) {
                return (
                    fk_assigned_primary_sp_id === 0 &&
                    requestRaised === 0 &&
                    closedByNoc === 0 &&
                    is_deleted === 0 &&
                    hardClose === 0 &&
                    (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 0)) &&
                    baseCondition
                );
            }
            return fk_assigned_primary_sp_id === 0 && requestRaised === 0 && closedByNoc === 0 && is_deleted === 0 && hardClose === 0 && baseCondition;
        },
    },
    {
        key: 'triggered',
        label: 'Triggered',
        tag: 'triggered',
        color: 'scogoorange',
        check: (
            {
                accepted_sp_id,
                requestRaised,
                closedByNoc,
                is_deleted,
                hardClose,
                reachedSite,
                signOffRequest,
                ticket_owned_by,
                assignToScogo,
                isOnHold,
                isEscalated,
                signOffReject,
            },
            { role, type }
        ) => {
            if (isScm(role, type)) {
                return (
                    accepted_sp_id === 0 &&
                    requestRaised === 1 &&
                    closedByNoc <= 0 &&
                    is_deleted === 0 &&
                    hardClose === 0 &&
                    reachedSite === 0 &&
                    signOffRequest === 0 &&
                    isOnHold === 0 &&
                    isEscalated === 0 &&
                    signOffReject === 0
                );
            } else if (isCustomerGroup(role, type)) {
                return (
                    accepted_sp_id === 0 &&
                    closedByNoc <= 0 &&
                    is_deleted === 0 &&
                    hardClose === 0 &&
                    reachedSite === 0 &&
                    signOffRequest === 0 &&
                    signOffReject === 0 &&
                    ((ticket_owned_by === 0 && requestRaised === 1) || (ticket_owned_by === 1 && assignToScogo === 1)) &&
                    isOnHold === 0 &&
                    isEscalated === 0
                );
            }
            return false;
        },
    },
    {
        key: 'planned',
        label: 'Planned',
        tag: 'planned',
        color: 'scogoprimary',
        check: ({ accepted_sp_id, reachedSite, closedByNoc, is_deleted, hardClose, signOffRequest, signOffAccept, isOnHold, isEscalated, signOffReject }, { role, type }) => {
            if (isSp(role, type) || isFe(role, type)) {
                return false;
            }
            return (
                signOffRequest === 0 &&
                signOffAccept === 0 &&
                accepted_sp_id !== 0 &&
                reachedSite === 0 &&
                closedByNoc <= 0 &&
                is_deleted === 0 &&
                hardClose === 0 &&
                isOnHold === 0 &&
                isEscalated === 0 &&
                signOffReject === 0
            );
        },
    },
    {
        label: 'Ongoing',
        tag: 'ongoing',
        color: 'scogobgsky',
        check: ({ signOffRequest, reachedSite, closedByNoc, is_deleted, hardClose, signOffAccept, isOnHold, isEscalated, signOffReject }) => {
            return (
                signOffRequest === 0 &&
                reachedSite === 1 &&
                closedByNoc <= 0 &&
                is_deleted === 0 &&
                hardClose === 0 &&
                signOffAccept === 0 &&
                isOnHold === 0 &&
                isEscalated === 0 &&
                signOffReject === 0
            );
        },
    },
    {
        key: 'on_hold',
        label: 'OnHold',
        tag: 'on_hold',
        color: 'scogoclosed',
        textTittle: 'Reason',
        check: ({ isOnHold, isEscalated, is_deleted, signOffAccept, hardClose }) =>
            (isOnHold === 1 || isEscalated === 1) && is_deleted === 0 && signOffAccept === 0 && hardClose === 0,

        getHoverText: ({ remarks } = {}) => {
            let holdRemark = ''
            if (Array.isArray(remarks)) {
                remarks.sort((a, b) => {
                    return new Date(a.created_at) - new Date(b.created_at);
                })
                const findElement = remarks.filter(remark => remark.event_master_id === 45)
                holdRemark = findElement[findElement.length - 1]?.remark ? findElement[findElement.length - 1]?.remark : ''

            }
            return holdRemark
        }
    },

    {
        key: 'sign_off_rejected',
        tag: 'sign_off_rejected',
        label: 'Sign Off Rejected',
        color: 'scogoclosed',
        textTittle: 'Reason',
        check: ({ signOffReject, is_deleted, signOffAccept, hardClose, isOnHold, isEscalated }) =>
            signOffReject === 1 && is_deleted === 0 && signOffAccept === 0 && hardClose === 0 && isOnHold === 0 && isEscalated === 0,
        getHoverText: ({ pm_rejection_message } = {}) => {

            return pm_rejection_message
        }
    },
    {
        label: 'Sign Off Requested',
        tag: 'sign_off_requested',
        labelClass: 'bg-scogoLightOrange font-medium py-1',
        shownNobgLabel: true,
        color: 'scogoorange',
        check: ({ signOffAccept, signOffRequest, is_deleted, hardClose, isOnHold, isEscalated, signOffReject }) =>
            signOffAccept === 0 && signOffRequest === 1 && is_deleted === 0 && hardClose === 0 && isOnHold === 0 && isEscalated === 0 && signOffReject === 0,


    },
    {
        key: 'site_complete',
        label: 'Site Complete',
        tag: 'site_complete',
        color: 'scogobgsky',
        check: ({ signOffAccept, is_deleted, hardClose, closedByNoc, isOnHold, isEscalated, signOffReject }) =>
            closedByNoc > 0 && is_deleted === 0 && hardClose === 0 && signOffAccept === 0 && isOnHold === 0 && isEscalated === 0 && signOffReject === 0,
    },
    {
        label: 'Hard Closed',
        tag: 'hard_closed',
        color: 'scogoclosed',
        check: ({ hardClose, is_deleted }, { role, type }) => {
            if (isSp(role, type) || isFe(role, type)) {
                return false;
            }
            return hardClose === 1 && is_deleted === 0;
        },
        getHoverText: ({ job_sign_off_notes } = {}) => {
            return validateStringValue(job_sign_off_notes);
        },
        textTittle: 'Reason',
    },

    {
        label: 'Revisit',
        tag: 'revisit',
        color: 'scogobgsky',
        check: ({ signOffRequest, isEscalated, isOnHold, revisitCount, is_revisit_required, hardClose, is_deleted }) => {
            return signOffRequest === 0 && (isEscalated === 1 || isOnHold === 1) && revisitCount === 1 && is_revisit_required === 1 && hardClose === 0 && is_deleted === 0;
        },
    },
    {
        label: 'Cancelled',
        tag: 'cancelled',
        color: 'scogo99',
        check: ({ is_deleted }) => {
            return is_deleted === 1;
        },
    },
];
// TODO check keys to keyur 
const isShowPendingDelivery = ({
    hard_copy_required,
    hard_copy_received,
    isEscalated,
    po_raised,
    signOffAccept,
    signOffRequest,
}) => {
    const basicConditon =
        isEscalated === 0 && po_raised === 0 && signOffAccept === 0 && signOffRequest === 1;

    if (hard_copy_required === 1 && hard_copy_received === 0) {
        return basicConditon;
    }

    return false;
};

export const actionLabelList = [
    {
        label: 'Pending Customer',
        icon: 'pending_actions',
        color: 'scogoorange',
        check: ({ signOffRequest, customerSignOffRequired, customerSignOffAccept, po_raised, accepted_fe_id, reachedSite }, { loggedUserRole }) => {
            return (
                SCM.role === loggedUserRole &&
                accepted_fe_id !== 0 &&
                reachedSite === 1 &&
                signOffRequest === 1 &&
                customerSignOffAccept === 0 &&
                customerSignOffRequired === 1 &&
                po_raised === 0
            );
        },
    },
    {
        label: 'Pending Scogo',
        icon: 'pending_actions',
        color: 'scogoorange',
        check: (
            { accepted_fe_id, reachedSite, signOffAccept, assignToScogo, signOffRequest, accepted_sp_id, customerSignOffRequired, customerSignOffAccept, ticket_owned_by },
            { loggedUserRole }
        ) => {
            return (
                accepted_fe_id !== 0 &&
                reachedSite === 1 &&
                signOffAccept === 0 &&
                signOffRequest === 1 &&
                accepted_sp_id !== 0 &&
                ((customerSignOffRequired === 1 && customerSignOffAccept === 1) || customerSignOffRequired === 0) &&
                (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1)) &&
                [CUSTOMER.role, CUSTOMER_ADMIN.role, CUSTOMER_USER.role].includes(loggedUserRole)
            );
        },
    },
    {
        label: 'Pending Cluster',
        icon: 'pending_actions',
        color: 'scogoorange',
        check: ({ signOffRequest, ticketType, accepted_fe_id, signOffAccept, reachedSite, isEscalated, serviceTypeId }) => {
            return (
                signOffRequest === 1 &&
                accepted_fe_id !== 0 &&
                signOffAccept === 0 &&
                reachedSite === 1 &&
                isEscalated === 0 &&
                ticketType === ticketTypes.support &&
                serviceTypeId === serviceTypeIds.migration
            );
        },
    },
    {
        label: 'Pending Docket',
        icon: 'local_shipping',
        color: 'scogoorange',
        check: (ticket) => {
            return isPendingDocket(ticket) && ticket.signOffRequest === 0;
        },
    },
    {
        label: 'Pending Delivery',
        icon: 'car_crash',
        color: 'scogobgsky',
        check: (ticket) => {
            return isShowPendingDelivery(ticket);
        },
    },

    {
        label: 'Closed',
        color: 'black',
        labelClass: 'bg-labelCloseBg border border-black text-black',
        check: ({ signOffAccept, signOffRequest, signOffReject, hardClose }) => (signOffAccept === 1 && signOffRequest === 1 && signOffReject === 0) || hardClose === 1,
    },
    {
        color: 'scogo2e',
        check: () => {
            return true;
        },
    },
];

export const ticketTypeList = [
    { label: 'Migration', color: 'scogoBasicYellow', tag: 'migration', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.migration },
    { label: 'Reconcile', color: 'scogoBasicYellow', tag: 'reconcile', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.reconcile },
    { label: 'Feasibility', color: 'scogoBasicYellow', tag: 'feasibility', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.feasibility },
    { label: 'Release Asset', color: 'scogoBasicYellow', tag: 'release_asset', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.release_asset },
    { label: 'Scrap Asset', color: 'scogoBasicYellow', tag: 'scrap_asset', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.scrap_asset },
    { label: 'Asset Replace', color: 'scogoBasicYellow', tag: 'asset_replace', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.asset_replace },
    {
        label: 'RMA Pending',
        color: 'scogobgsky',
        hoverText: 'RMA',
        tag: 'rma_pending',
        check: ({ isRmaRaised, ticketType, cl_rma_response, is_deleted, hardClose, isOnHold, isEscalated, signOffReject, signOffAccept }) =>
            ticketType === ticketTypes.field &&
            isRmaRaised === 1 &&
            ['', undefined, null].includes(cl_rma_response) &&
            is_deleted === 0 &&
            hardClose === 0 &&
            isOnHold === 0 &&
            signOffAccept === 0
    },
    {
        label: 'RMA Updated',
        color: 'scogoorange',
        hoverText: 'RMA',
        tag: 'rma_updated',
        check: ({ isRmaRaised, ticketType, cl_rma_response, is_deleted, hardClose, isOnHold, isEscalated, signOffReject, signOffAccept }) =>
            ticketType === ticketTypes.field &&
            isRmaRaised === 1 &&
            !['', undefined, null].includes(cl_rma_response) &&
            is_deleted === 0 &&
            hardClose === 0 &&
            isOnHold === 0
    },
    { label: 'Support', color: 'scogoBasicYellow', tag: 'support', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.support },
    { label: 'RL', color: 'scogobgsky', tag: 'rl', check: ({ serviceTypeId }) => serviceTypeId === serviceTypeIds.reverse_logistics },
    { label: 'PO', color: 'scogoBasicYellow', tag: 'po', check: ({ po_raised }) => po_raised === 1 },
];

export const progressStatusList = [
    {
        label: 'SP Unassigned',
        color: 'scogoclosed',
        check: (ticket, { role, type }) => {
            const { fk_assigned_primary_sp_id, requestRaised, closedByNoc, is_deleted, hardClose, accepted_sp_id, reachedSite, assignToScogo, ticket_owned_by } = ticket;
            if (isCluster(role, type) || isSuperVisor(role, type) || isPsp(role, type)) {
                return accepted_sp_id === 0 && requestRaised === 1 && closedByNoc === 0 && is_deleted === 0 && hardClose === 0 && reachedSite === 0;
            } else if (isCustomerGroup(role, type)) {
                return (
                    fk_assigned_primary_sp_id === 0 &&
                    requestRaised === 0 &&
                    closedByNoc === 0 &&
                    is_deleted === 0 &&
                    hardClose === 0 &&
                    (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 0))
                );
            }
            return fk_assigned_primary_sp_id === 0 && requestRaised === 0 && closedByNoc === 0 && is_deleted === 0 && hardClose === 0;
        },
        statusComplete: `0`,
    },
    {
        label: 'Assign To Scogo',
        color: 'scogoBasicYellow',
        check: (ticket, { role, type }) => {
            const { fk_assigned_primary_sp_id, requestRaised, closedByNoc, is_deleted, hardClose, assignToScogo, ticket_owned_by } = ticket;
            if (isCustomerGroup(role, type)) {
                return (
                    fk_assigned_primary_sp_id === 0 &&
                    requestRaised === 0 &&
                    closedByNoc === 0 &&
                    is_deleted === 0 &&
                    hardClose === 0 &&
                    (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1))
                );
            }
            return false;
        },
        statusComplete: `10`,
    },
    {
        label: 'Waiting for SP Ticket Acceptance',
        color: 'scogoBasicYellow',
        check: (ticket, { role, type }) => {
            const { accepted_sp_id, requestRaised, closedByNoc, is_deleted, hardClose, reachedSite, signOffRequest } = ticket;
            if (isSp(role, type) || isFe(role, type)) return false;
            return accepted_sp_id === 0 && requestRaised === 1 && closedByNoc === 0 && is_deleted === 0 && hardClose === 0 && reachedSite === 0 && signOffRequest === 0;
        },
        statusComplete: `10`,
    },
    {
        label: 'FE Accepted Ticket But Not Reached Site',
        color: 'scogoorange',
        check: (ticket, { role, type }) => {
            const { accepted_sp_id, signOffAccept, closedByNoc, is_deleted, hardClose, reachedSite, signOffRequest, accepted_fe_id } = ticket;
            if (isSp(role, type) || isFe(role, type)) {
                return false;
            }
            return (
                signOffRequest === 0 &&
                signOffAccept === 0 &&
                accepted_sp_id !== 0 &&
                reachedSite === 0 &&
                closedByNoc === 0 &&
                is_deleted === 0 &&
                hardClose === 0 &&
                accepted_fe_id !== 0
            );
        },
        statusComplete: `20`,
    },
    {
        label: 'FE Reached Site / Work In Progress',
        color: 'scogoorange',
        check: (ticket) => {
            const { signOffAccept, signOffReject, closedByNoc, is_deleted, hardClose, reachedSite, signOffRequest } = ticket;
            return signOffRequest === 0 && reachedSite === 1 && closedByNoc === 0 && is_deleted === 0 && hardClose === 0 && signOffAccept === 0 && signOffReject === 0;
        },
        statusComplete: `40`,
    },
    {
        label: 'Ticket On Hold',
        color: 'scogoclosed',
        check: (ticket) => {
            const { signOffAccept, isOnHold, is_deleted, hardClose, isEscalated } = ticket;
            return (isOnHold === 1 || isEscalated === 1) && is_deleted === 0 && signOffAccept === 0 && hardClose === 0;
        },
        statusComplete: `50`,
    },
    {
        label: (ticket, { onClick }) => <RenderRemark ticket={ticket} onClick={onClick} />, // Site Complete
        color: '',
        check: (ticket) => {
            const { signOffAccept, closedByNoc, is_deleted, hardClose, signOffRequest } = ticket;
            return closedByNoc > 0 && is_deleted === 0 && hardClose === 0 && signOffAccept === 0 && signOffRequest === 0;
        },
        statusComplete: `50`,
    },
    {
        label: (ticket, { onClick }) => <RenderRemark ticket={ticket} onClick={onClick} />, // Signoff Request
        color: '',
        check: (ticket) => {
            const { signOffAccept, signOffRequest, is_deleted, hardClose } = ticket;
            return signOffAccept === 0 && signOffRequest === 1 && is_deleted === 0 && hardClose === 0;
        },
        statusComplete: `80`,
    },
    {
        label: (ticket, { onClick }) => <RenderRemark ticket={ticket} onClick={onClick} />, // Sign off Approved
        color: '',
        check: (ticket) => {
            const { signOffAccept, signOffRequest, is_deleted, hardClose } = ticket;
            return signOffAccept === 1 && signOffRequest === 1 && is_deleted === 0 && hardClose === 0;
        },
        statusComplete: `100`,
    },
    {
        label: (ticket, { onClick }) => <RenderRemark ticket={ticket} onClick={onClick} />, // hard CLosed Tickets
        color: '',
        check: (ticket) => {
            const { is_deleted, hardClose } = ticket;
            return is_deleted === 0 && hardClose === 1;
        },
        statusComplete: `100`,
    },
];

const isEligibleForAssignTechSupport = ({ signOffAccept, signOffRequest, closedByNoc, ticket_owned_by, assignToScogo, role, type }) => {
    if (isScm(role, type) || isCustomerAdmin(role, type) || isCustomer(role, type)) return signOffAccept === 0 && closedByNoc <= 0 && signOffRequest === 0 && (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1));
    return false;
};

const isEligibleForCustomerApprovalRecieved = ({ ticket_owned_by, assignToScogo, role, type }) => {
    if (isScm(role, type)) return ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1);
    return false;
};

export const isEligibleForEditExecutionDate = ({ signOffAccept, signOffRequest, ticket_owned_by, assignToScogo, role, type, closedByNoc, accepted_sp_id, sign_off_lock }) => {
    let base;
    if (isScm(role, type) || isCluster(role, type) || isSuperVisor(role, type)) {
        base = signOffAccept === 0 && signOffRequest === 0 && (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1)) && sign_off_lock === 0;
        if (closedByNoc > 0) {
            base = base && accepted_sp_id === 0;
            return base;
        }
        return base;
    }
    if (isCustomer(role, type) || isCustomerAdmin(role, type)) {
        base = signOffAccept === 0 && signOffRequest === 0 && ticket_owned_by === 1 && assignToScogo === 0;
        if (closedByNoc > 0) {
            base = base && accepted_sp_id === 0;
            return base;
        }
        return base;
    }
    return false;
};

const isEligibleForShareFeasibilityLink = ({ serviceTypeId, signOffAccept, role, type }) =>
    signOffAccept === 0 && serviceTypeId === serviceTypeIds.feasibility && (isScm(role, type) || isCluster(role, type) || isCustomerGroup(role, type));

const isEligibleForrequestToTrackFe = ({ is_live_tracking_enabled, execution_date, reachedSite, ticketType, accepted_fe_id }) => {
    let executionDate = moment(execution_date).format('YYYY-MM-DD');
    let today = moment().format('YYYY-MM-DD');
    return today === executionDate && is_live_tracking_enabled !== 1 && reachedSite === 0 && ticketType === 0 && accepted_fe_id !== 0;
};

export const isToShowHoldIcon = ({ signOffRequest, isOnHold, isEscalated, hardClose }) => {
    return signOffRequest === 0 && isOnHold === 0 && isEscalated === 0 && hardClose === 0;
};


export const isToShowResumeIcon = ({ isEscalated, isOnHold, signOffRequest }, { role, type }) => {
    return signOffRequest === 0 && (isOnHold === 1 || isEscalated === 1) && (isCustomerGroup(role, type) || isScm(role, type) || isCluster(role, type));
};
export const isToShowBulkResumeIcon = ({ isEscalated, isOnHold, signOffRequest }) => {
    return signOffRequest === 0 && (isOnHold === 1 || isEscalated === 1)
};

export const isShoHardCloseIcon = ({ signOffRequest, hardClose }, { role, type }) => {
    return signOffRequest === 0 && hardClose === 0 && (isCustomerGroup(role, type) || isScm(role, type));
};

const isEligibleForDeleteTicket = ({ reachedSite, signOffRequest, isOnHold, isEscalated, closedByNoc }) => {
    return reachedSite === 0 && signOffRequest === 0 && isOnHold === 0 && isEscalated === 0 && closedByNoc === 0;
};

const isEligibleForTrackFe = ({ is_live_tracking_enabled, execution_date, reachedSite, ticketType }) => {
    let executionDate = moment(execution_date).format('YYYY-MM-DD');
    let today = moment().format('YYYY-MM-DD');
    return today === executionDate && is_live_tracking_enabled === 1 && reachedSite === 0 && ticketType === 0;
};
const isPoRaised = ({ po_raised }) => po_raised === 1;
const isEligibleForupdatesignoff = ({ signOffRequest, job_sign_off_notes }) => signOffRequest === 1 && !['', null, undefined].includes(job_sign_off_notes);

const updateRmaDetails = {
    key: 'update_rma_details',
    conditionalRendering: (ticket) => {
        const { cl_rma_response } = ticket;
        if (cl_rma_response) {
            return { menuName: 'Edit RMA Details', menuIcon: 'app_registration', iconColor: 'text-scogoprimary' };
        }
        return { menuName: 'Update RMA Details', menuIcon: 'app_registration', iconColor: 'text-scogoprimary' };
    },
    onClick: (ticket, dispatch) => {
        const { cl_rma_response } = ticket;
        return dispatch(
            openFullscreenModal({
                heading: (
                    <span className='text-black'>
                        {cl_rma_response ? 'Edit RMA Details' : 'Update RMA Details'} :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span>
                    </span>
                ),
                modalWidth: '70rem',
                modalHeight: 'auto',
                modalComponent: <UpdateRmaDetails id={ticket.id} heading={"Update RMA Details"} />,
            })
        );
    },
};

const shareFeasibilityLink = {
    key: 'share_feasibility_link',
    menuName: 'Share Feasibility Link',
    menuIcon: 'share',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const isps = [];
        return dispatch(
            openCustomModal({
                heading: 'Share Feasibility Link',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <ShareFeasibilityLink ticketId={ticket.id} isps={isps} />,
            })
        );
    },
    isDisabled: (ticket, { loggedUser }) => {
        return { disabled: ticket.signOffAccept === 1, message: "Can't Share" };
    },
};


export const deleteTicket = {
    key: 'delete_ticket',
    menuName: 'Delete Ticket',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (ticket, dispatch) => {
        let formName = 'deleteTicket';
        let heading = 'Delete Ticket';
        let text = `Are you sure you want to Delete Ticket?`;
        let data = { ticketIds: [ticket.id] };
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(deleteTicketsRequest({ data, formName })),
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        let closeOnBackdropClick = false;

        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName }));
    },
    isDisabled: ({ reachedSite, signOffRequest, isOnHold, isEscalated, closedByNoc }, _) => {
        return {
            disabled: !isEligibleForDeleteTicket({ reachedSite, signOffRequest, isOnHold, isEscalated, closedByNoc }),
            message: 'Delete At This Stage Is Not Allowed',
        };
    },
};

const siteComplete = {
    key: 'site_complete',
    menuName: 'Site Complete',
    menuIcon: 'domain',
    iconColor: 'text-scogoprimary',

    onClick: (ticket, dispatch, { loggedUser }) => {
        const type = loggedUser.type;
        const role = loggedUser.role.id;
        if (isScm(role, type) && !ticket?.rating?.id && ticket.accepted_fe_id !== 0 && ticket.accepted_sp_id !== 0) {
            let heading = `Are you sure your site is completed?`;
            let modalComponent = <FeRating ticketDetails={ticket} ticketId={ticket.id} isSiteCompletd={true} submitButtonText={'Yes'} cancelButtonText={'No'} />;

            let modalWidth = '45rem',
                modalHeight = 'auto';
            dispatch(openCustomModal({ modalComponent, heading, modalWidth, modalHeight }));
        } else {
            let formName = 'siteCompleteformName';
            let heading = 'Site Completed';
            let text = `Are you sure you site is completed ?`;
            const serial_number = ticket?.assets[0]?.serial_number;
            const cnergeeProjectIds = [2263, 2285, 2311, 2313];
            const callCnergeeExecuteCheckApi = (config.name === devConfig.name && parseInt(ticket.fk_project_id) === 1964) || (config.name === prodConfig.name && cnergeeProjectIds.includes(parseInt(ticket.fk_project_id)));

            let buttons = [
                {
                    showLoading: true,
                    textOrComponent: 'Yes',
                    type: 'blue',
                    onClick: () => dispatch(siteCompleted({ ticketId: ticket.id, formName, serial_number, callCnergeeExecuteCheckApi })),
                },
                {
                    textOrComponent: 'No',
                    type: 'red',
                    buttonClass: 'hover:bg-scogoLightFillRed',
                    onClick: () => dispatch(closeModalAction()),
                },
            ];
            let closeOnBackdropClick = false;

            dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName }));
        }
    },
};

const releaseTicket = {
    key: 'release_ticket',
    menuName: 'Release ticket',
    menuIcon: 'lock_reset',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch) => {
        let formName = 'release_modal';
        let heading = 'Release Ticket';
        let text = `Are you sure you want to continue ?`;
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'blue',
                onClick: () => dispatch(withdrawTicket({ data: { ticket_id: ticket?.id }, formName, refresh: true })),
            },
            {
                textOrComponent: 'No',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        let closeOnBackdropClick = false;

        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName }));
    },
};


const executeTicket = {
    key: 'execute_ticket',
    menuName: 'Execute Ticket',
    menuIcon: 'confirmation_number',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch, { navigate } = {}) => {
        let path = `/tickets/${ticket.id}/execute/initiate`;
        if (ticket.signOffRequest === 1) {
            path = `${path}?editWorkFlow=true`;
        }
        window.open(path);
    },
};

const updateDigitalForm = {
    key: 'update_digital_form',
    menuName: 'Update Digital Form',
    menuIcon: 'confirmation_number',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch, { navigate } = {}) => {
        const path = `/tickets/${ticket.id}/execute/initiate?editSignOffForm=true`;
        window.open(path);
    },
};

export const approvePo = {
    key: 'approve_po',
    menuName: 'Approve po',
    menuIcon: 'fact_check',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch, { navigate } = {}) => {
        let modalComponent = <PoApproval ticketId={ticket.id} />;
        dispatch(openFullscreenModal({ modalComponent }));
    },
};

export const feasibilityAction = {
    key: 'feasibility',
    menuName: 'Feasibility',
    menuIcon: 'cell_tower',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch, { navigate } = {}) => {
        let heading = 'Close Feasibility';
        let isOnlyView = false;
        if (ticket.signOffAccept === 1) {
            heading = 'View Feasibility';
            isOnlyView = true;
        }
        let modalComponent = <CloseFeasibility isOnlyView={isOnlyView} ticketId={ticket?.id} heading={heading} />;
        dispatch(openFullscreenModal({ heading, modalComponent }));
    },
};

export const updateHardCopyStatus = {
    key: 'update_docket',
    menuName: 'HardCopy Status',
    menuIcon: 'local_shipping',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch, { navigate } = {}) => {
        const formName = 'hard_copy_received';
        let heading = 'Hard Copy Received?';
        let text = `Are you sure you have received hard copy?`;
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'blue',
                buttonClass: 'hover:bg-scogobgsky',
                onClick: () =>
                    dispatch(
                        updateDocketDetails({
                            data: { action: 'HARD_COPY_RECEIVED', ticket_id: ticket?.id },
                            formName,
                            callCloseTicket: false
                        })
                    ),
            },
            {
                textOrComponent: 'No',
                type: 'redOutlined',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(closeModalAction()),
            },
        ];

        let closeOnBackdropClick = false;
        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName }));
    },
};

const raisePO = {
    key: 'raise_po',
    menuName: 'Raise PO',
    menuIcon: 'post_add',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const identification = validateStringValue(ticket?.ticket_number);
        const heading = (
            <>
                <span className='text-black'>
                    Raise PO |&nbsp;<span className='text-scogobgsky text-font16'>{identification}</span>
                </span>
            </>
        );
        return dispatch(
            openFullscreenModal({
                modalComponent: <RaisePo ticketId={ticket.id} isRefresh heading={heading} />,
            })
        );
    },
};

const updatePo = {
    key: 'update_po',
    menuName: 'Update Po',
    menuIcon: 'edit_note',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        return dispatch(
            openFullscreenModal({
                modalComponent: <RenderUpdatePo ticketId={ticket.id} ticket={ticket} isRefresh />,
            })
        );
    },
};

const addNewPincode = {
    key: 'add_new_pincode',
    menuName: 'Add New Pincode',
    menuIcon: 'add_circle_outline',
    iconColor: 'text-scogobgsky',
    onClick: (detail, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Add New Pincode',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <AddNewPincode />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const bulkCloneTicket = {
    key: 'bulk_clone_ticket',
    menuName: 'Bulk Clone Ticket',
    menuIcon: 'content_copy',
    iconColor: 'text-scogobgsky',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const formName = 'bulkCloneTicket';
        let ticket_ids = [];
        let tickets = getSelectedTickets();
        if (tickets.length > 0) {
            ticket_ids = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }

        return dispatch(
            openTextModalAction({
                heading: 'Bulk Clone',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                selectedCount: ticket_ids.length,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        onClick: () => {
                            dispatch(bulkCloneServiceRequest({ formName, payload: { ticket_ids } }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
    isDisabled: (_, { getSelectedTickets = () => { } } = {}) => {
        return false;
    },
};

const bulkDeleteTicket = {
    key: 'bulk_delete_ticket',
    menuName: 'Delete Tickets',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        let formName = 'deleteTickets';
        let heading = 'Delete Tickets';
        let text = `Are you sure you want to Delete Tickets?`;
        let ticket_ids = [];
        let tickets = getSelectedTickets();
        tickets = tickets.filter((ticket) => {
            return true
        });
        if (tickets.length > 0) {
            ticket_ids = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(bulkDeleteServiceRequest({ formName, payload: { ticket_ids } })),
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        let closeOnBackdropClick = false;

        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName, selectedCount: ticket_ids.length }));
    },
};


const bulkUpdateHardCopyStatus = {
    key: 'bulk_update_hardcopy_recieved_status',
    menuName: 'HardCopy Status',
    menuIcon: 'local_shipping',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets, loggedUser } = {}) => {
        let formName = 'bulk_update_hardcopy_recieved_status';
        let heading = 'Hard Copy Received?';
        let text = `Are you sure you have received hard copy?`;
        let ticketIds = [];
        let tickets = getSelectedTickets();
        const type = loggedUser.type;
        const role = loggedUser.role.id;
        if (tickets.length === 0) {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }
        tickets = tickets.filter((ticket) => {
            return getIsToShowPendingDelivery({ ticket, role, type })
        });
        if (tickets.length > 0) {
            ticketIds = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Selected tickets are not eligible for update hardcopy status', status: 'warning' }));
        }
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'blue',
                buttonClass: 'hover:bg-scogobgsky',
                onClick: () =>
                    dispatch(
                        bulkHardCopyRecievedUpdate({
                            ticketIds,
                            formName,
                        })
                    ),
            },
            {
                textOrComponent: 'No',
                type: 'redOutlined',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        let closeOnBackdropClick = false;
        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName, selectedCount: ticketIds.length }));
    },
};

const bulkUpdateTicketDates = {
    key: 'bulk_update_ticket_dates',
    menuName: 'Update Ticket Dates',
    menuIcon: 'calendar_month',
    iconColor: 'text-scogobgsky',
    onClick: (_, dispatch, { getSelectedTickets, loggedUser } = {}) => {
        return dispatch(
            openCustomModal({
                heading: 'Update Ticket Dates',
                modalWidth: '30rem',
                modalHeight: 'auto',
                modalComponent: <UpdateTicketDate />,
            })
        );
    },
};

const requestToTrackFE = {
    key: 'request_to_track_fe',
    menuName: 'Request to track FE',
    menuIcon: 'directions_bike',
    iconColor: 'text-yellow-500',
    onClick: (ticket, dispatch) => {
        let formName = 'requesttotrackFE';
        let heading = 'Request to track FE';
        let text = `Are you sure you want to sent request to track FE ?`;
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(requestTrackFE({ ticketId: ticket?.id, formName })),
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        dispatch(openTextModalAction({ heading, text, buttons, formName }));
    },
};

const trackFe = {
    key: 'track_fe',
    menuName: 'Track Fe',
    menuIcon: 'directions_bike',
    iconColor: 'text-scogosuccess',
    onClick: (ticket, dispatch, { navigate } = {}) => {
        if (ticket?.live_tracking_url) {
            window.open(ticket?.live_tracking_url);
        } else {
            dispatch(sendToastMessage({ message: 'Tracking Details Not Found', status: 'warning' }))
        }
    },
};

const bulkAssign = {
    key: 'bulk_assign',
    menuName: 'Bulk Assign',
    menuIcon: 'manage_accounts',
    iconColor: 'text-scogoToastSuccess',
    onClick: (_, dispatch, { getSelectedTickets, loggedUser } = {}) => {
        const role = loggedUser.role.id;
        const type = loggedUser.type;
        const frontend_controller = loggedUser.frontend_controller;
        let ticketIds = [];
        let tickets = getSelectedTickets();
        let heading = 'Bulk Assign';
        if (tickets.length > 0) {
            tickets = tickets.filter((ticket) => {
                return getIsShowAssignTicketButton({ role, type, ticket, frontend_controller }) && ticket.accepted_sp_id === 0;
            });
            ticketIds = tickets.map((ticket) => {
                return ticket.id;
            });

            if (tickets.length === 0) {
                return dispatch(sendToastMessage({ message: 'Tickets Are Not Eligible For Assign', status: 'warning' }));
            }
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }

        return dispatch(
            openCustomModal({
                heading,
                modalWidth: '60rem',
                modalHeight: 'auto',
                selectedCount: ticketIds.length,
                modalComponent: <AssignSP isBulk={true} isReassign={false} ticketIds={ticketIds} ticket={tickets[0]} />,
            })
        );
    },
    isDisabled: (partner) => {
        return false;
    },
};

const bulkHoldTicket = {
    key: 'bulk_hold_ticket',
    menuName: 'Bulk Hold Tickets',
    menuIcon: 'pause',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const formName = 'HoldForm';
        let ticketIds = [];
        let tickets = getSelectedTickets();
        tickets = tickets.filter((ticket) => {
            return true;
        });

        if (tickets.length > 0) {
            if (tickets.length === 0) {
                return dispatch(sendToastMessage({ message: 'Tickets Are Not Eligible For Assign', status: 'warning' }));
            }
            ticketIds = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }



        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Hold Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: isMobileView ? '35rem' : '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={tickets[0].org_id} />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {
                let p = { ticket_ids: ticketIds };
                if (processed_remark?.value) {
                    p.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        p.master_remark_id = processed_remark.value;
                    }
                }
                dispatch(bulkServiceRequestStateChange({
                    payload: p,
                    formName,
                    state: 'hold'
                }));
            }
        });
    },
    isDisabled: () => {
        return false;
    },
};

const bulkResumeTicket = {
    key: 'bulk_resume_ticket',
    menuName: 'Bulk Resume Tickets',
    menuIcon: 'play_arrow',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const formName = 'HoldForm';
        let ticketIds = [];
        let tickets = getSelectedTickets();
        tickets = tickets.filter((ticket) => {
            return true;
        });
        if (tickets.length > 0) {
            if (tickets.length === 0) {
                return dispatch(sendToastMessage({ message: 'Tickets Are Not Eligible For Assign', status: 'warning' }));
            }
            ticketIds = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }

        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Resume Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={tickets[0].org_id} />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {
                let p = { ticket_ids: ticketIds };
                if (processed_remark?.value) {
                    p.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        p.master_remark_id = processed_remark.value;
                    }
                }
                dispatch(bulkServiceRequestStateChange({
                    payload: p,
                    formName,
                    state: 'resume'
                }));
            }
        });
    },
    isDisabled: () => {
        return false;
    },
};

const bulkUploadSite = {
    key: 'bulk_upload_sites',
    menuName: 'Bulk Create Ticket',
    menuIcon: 'upload',
    iconColor: 'text-scogobgsky',
    onClick: (_, dispatch, { getSelectedTickets, loggedUser } = {}) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Create Ticket',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'TICKET_CREATE'} />,
            })
        );
    },
    isDisabled: (partner) => {
        return false;
    },
};

const bulkAssetConfigCreation = {
    key: 'bulk_asset_config_creation',
    menuName: 'Bulk Asset Config',
    menuIcon: 'tune',
    iconColor: 'text-scogoprimary',
    onClick: (_, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Asset Config',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'ASSET_CONFIG_CREATE'} />,
            })
        );
    },
    isDisabled: () => {
        return false;
    },
};

const updateSignOffNotes = {
    key: 'update_sign_off_notes',
    menuName: 'Update SignOff Remark',
    menuIcon: 'note_alt',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Update SignOff Remark',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <UpdateSignOffNotes ticketId={ticket.id} milestones={ticket.milestones} agents={ticket.agents} />,
            })
        );
    },
};

const appointment = {
    key: 'appointment',
    menuName: 'Ask Appointment',
    menuIcon: 'note_alt',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Ask Appointment',
                modalWidth: '40rem',
                modalHeight: 'auto',
                modalComponent: <CreateAppointment ticketId={ticket.id} />,
            })
        );
    },
};
const downloadConfigTemplate = {
    key: 'download_config_template',
    menuName: 'Asset Config Template',
    imgIcon: '/img/zipDownload.png',
    onClick: (ticket, dispatch) => {
        dispatch(getAssetConfigTemplate(ticket?.id));
    },
    isDisabled: (ticket, { loggedUser }) => {
        const type = loggedUser.type;
        const role = loggedUser.role.id;
        return {
            disabled: !showDownloadAssetConfig(ticket, { role, type }),
            message: 'No reports for download',
        };
    },
};

const downloadCustomer = {
    key: 'download_customer_report',
    menuName: 'Customer Sign Off Report',
    imgIcon: './img/pdfDownload.png',
    onClick: (ticket, dispatch) => {
        dispatch(downloadCustomerReport({ ticketId: ticket?.id, attachmentIds: [], isTicketDetails: true, formName: '' }));
    },
    isDisabled: (ticket, { loggedUser }) => {
        const type = loggedUser.type;
        const role = loggedUser.role.id;
        return {
            disabled: !showDownloadScogoReport(ticket, { role, type }),
            message: 'No reports for download',
        };
    },
};
const downloadScogoReport = {
    key: 'download_scogo_report',
    menuName: 'Scogo Sign Off Report',
    imgIcon: './img/pdfDownload.png',
    onClick: (ticket, dispatch) => {
        dispatch(getTicketReportLink({ ticketId: ticket?.id }));
        if (ticket.fk_sign_off_template_id > 0) {
            dispatch(updateSignOffSteps({ ticketId: ticket?.id, download: true }));
        }
    },
    isDisabled: (ticket, { loggedUser }) => {
        const type = loggedUser.type;
        const role = loggedUser.role.id;
        return {
            disabled: !showDownloadScogoReport(ticket, { role, type, isScogoReport: true }),
            message: 'No reports for download',
        };
    },
};

const addAsset = {
    key: 'add_asset',
    menuName: 'Add Asset',
    menuIcon: 'queue_play_next',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch, { navigate }) => {
        navigate(`/tickets/${ticket.id}/edit?addAsset=true`);
    },
};

export const addDocket = {
    key: 'add_docket',
    menuName: 'Pending Docket',
    menuIcon: 'local_shipping',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch, { navigate }) => {
        window.open(`/tickets/${ticket?.id}/execute/initiate`);
    },
};

const holdTicket = {
    key: 'hold_ticket',
    menuName: 'Hold Ticket',
    menuIcon: 'pause',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const formName = 'hold_ticket_controller';
        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Hold Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: isMobileView ? '35rem' : '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={ticket.org_id} category='HOLD' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {

                let p = { ticketId: ticket.id, state: 'hold' };
                let remark = {};
                if (processed_remark?.value) {
                    remark.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        remark.master_remark_id = processed_remark.value;
                    }
                }
                p.remark = remark;
                dispatch(holdOrResumeServiceRequest({
                    payload: p,
                    formName
                }));
            }
        });
    },
};

const resumeTicket = {
    key: 'resume_ticket',
    menuName: 'Resume Ticket',
    menuIcon: 'play_arrow',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const formName = 'resume';
        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Resume Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={ticket.org_id} category='RESUME' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {
                let p = { ticketId: ticket.id, state: 'resume' };
                let remark = {};
                if (processed_remark?.value) {
                    remark.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        remark.master_remark_id = processed_remark.value;
                    }
                };
                p.remark = remark;
                dispatch(holdOrResumeServiceRequest({
                    payload: p,
                    formName
                }));
            }
        });
    },
};

const hardCloseTicket = {
    key: 'hard_close_ticket',
    menuName: 'Hard Close',
    menuIcon: 'not_interested',
    iconColor: 'text-scogoclosed',
    onClick: (ticket, dispatch) => {
        let heading = <span className='text-black'>Hard Close Ticket</span>;
        let modalComponent = <HardCloseTicket id={ticket.id} milestones={ticket.milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = '50rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
    isDisabled: () => {
        return false;
    },
};

const addPrice = {
    key: 'add_new_price',
    menuName: 'Add Price',
    menuIcon: 'currency_rupee',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch, { loggedUser, navigate }) => {
        const type = loggedUser.type;
        const role = loggedUser.role.id;
        openTicketPaymentModal(ticket, { dispatch, role, type, navigate });
    },
    isDisabled: () => {
        return false;
    },
};

const reAssign = {
    key: 're_assign',
    menuName: 'ReAssign',
    menuIcon: 'manage_accounts',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch, { loggedUser }) => {
        let heading = (
            <span className='text-black'>
                ReAssign :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
            </span>
        );
        let modalComponent = <AssignSP ticket={ticket} isReassign={'Assign'} />;
        let modalHeight = 'auto',
            modalWidth = '60rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
    isDisabled: () => {
        return false;
    },
};


const reGenrateScogoReport = {
    key: 'regenerate_scogo_report',
    menuName: 'Regenerate Sign Off Report',
    menuIcon: 'description',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch, { loggedUser } = {}) => {
        let emails = [];
        if (config.name === prodConfig.name) {
            emails.push('nitin@scogo.in');
        } else {
            emails.push('alpesh@scogo.in');
        }
        if (loggedUser) {
            emails.push(loggedUser?.email);
        }
        emails = emails.filter((item) => item !== undefined);
        emails = [...new Set(emails)];
        const payload = {
            ticket_id: ticket.id,
            emails: [...emails].join(','),
        };
        dispatch(emailReport({ data: payload, downloadReport: true }));
    },
    isDisabled: (ticket, { loggedUser }) => {
        const type = loggedUser.type;
        const role = loggedUser.role.id;
        return {
            disabled: !showDownloadScogoReport(ticket, { role, type }),
            message: 'No reports for download',
        };
    },
};

const unlockSignoffAction = {
    key: 'unlock_signoff',
    menuName: 'Unlock Signoff',
    menuIcon: 'key',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        let heading = (
            <span className='text-black'>
                Unlock Signoff :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
            </span>
        );
        let modalComponent = <UnlockSignoff ticketId={ticket.id} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = '40rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
}


const notifyTicketDetailsToEndCustomer = {
    key: 'notify_ticket_details_to_end_customer',
    menuName: 'Notify End Customer',
    menuIcon: 'notifications',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch, { loggedUser }) => {
        let heading = (<span className='text-black'>Notify Ticket Details to End Customer</span>);
        let mobile;
        if (ticket?.local_contact_mobile) mobile = ticket?.local_contact_mobile;
        const role = loggedUser && loggedUser.role.id;
        const type = loggedUser && loggedUser.type;
        const ticket_status = ticketStatusList.find((item) => item.check(ticket, { role, type }));

        let address = ticket?.site_address;
        let site_id = ticket?.external_site_id;

        return dispatch(
            openCustomModal({
                heading,
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <NotifyTicketDetailsToEndCustomer site_id={site_id} address={address} ticket_number={ticket?.ticket_number} mobile={mobile} ticketId={ticket?.id || ticket?.id} status={ticket_status ? ticket_status.label : ''} />,
            })
        );
    },



};

const showDownloadScogoReport = (ticket, { role, type, isScogoReport }) => {
    const { ticketType, signOffRequest, hardClose, is_deleted } = ticket;
    if ((isSp(role, type) || isFe(role, type) || isIsp(role, type)) && !isScogoReport) {
        return false;
    }

    return ticketType === 0 && signOffRequest === 1 && hardClose === 0 && is_deleted === 0;
};

const showDownloadAssetConfig = (ticket, { role, type }) => {
    const { asset_config_required, signOffRequest, signOffAccept, hardClose, is_deleted } = ticket;
    return asset_config_required === 1 && signOffAccept === 0 && signOffRequest === 0 && hardClose === 0 && is_deleted === 0;
};

const isEligibleForDelete = (role, type, { ticket_owned_by, assignToScogo, reachedSite }) => {
    if (isCustomer(role, type) || isCustomerAdmin(role, type)) {
        return ticket_owned_by === 1 && assignToScogo === 0 && reachedSite === 0;
    }
    if (isScm(role, type)) {
        return (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1)) && reachedSite === 0;
    }
    return false;
};

const downloadsAllReport = {
    key: 'downloads_reports',
    menuName: 'Downloads Report',
    menuIcon: 'file_download',
    iconColor: 'text-scogobgsky hover:text-scogoorange',
    subMenus: [reGenrateScogoReport, downloadScogoReport, downloadCustomer, downloadConfigTemplate],
};

export const getIsShowAssignTicketButton = ({ role, type, ticket, frontend_controller }) => {
    const { ticket_owned_by, ticketType, isRmaRaised, isEscalated, hardClose, signOffAccept, signOffRequest, closedByNoc, accepted_sp_id, additional_amount_paid, sign_off_lock, assignToScogo } = ticket;

    const ticketOwner = getTicketOwner({ ticket_owned_by, assign_to_scogo: assignToScogo })
    if (ticketOwner === 'Customer') {
        // always giving assign/reassign option when ticket owner is customer
        return true;
    }

    let showAssign = sign_off_lock === 0 &&
        isEscalated === 0 &&
        ((ticketType === ticketTypes.field && isRmaRaised === 0) || (ticketType === ticketTypes.field && isRmaRaised === 1)) &&
        hardClose === 0 &&
        signOffAccept === 0 &&
        signOffRequest === 0 &&
        !(additional_amount_paid > 0)
    if (closedByNoc > 0) {
        showAssign = showAssign && accepted_sp_id === 0;
    }
    if (isScm(role, type) || isCluster(role, type) || isSuperVisor(role, type)) {
        return showAssign && isAssignAllowed(frontend_controller);
    } else if (isCustomer(role, type) || isCustomerAdmin(role) || isCustomerUser(role)) {
        return showAssign && ticket_owned_by === 1;
    } else if (isPsp(role, type) || isSp(role, type)) {
        return showAssign;
    }
    return false;
};

export const getIsshowReleaseTicketButton = ({ ticket, role, type, loggedUserId }) => {
    const { signOffRequest, accepted_fe_id, accepted_sp_id, isEscalated, hardClose, closedByNoc, ticketType, isRmaRaised } = ticket;

    const showRelease =
        (isScm(role, type) || loggedUserId === accepted_sp_id) &&
        signOffRequest === 0 &&
        accepted_fe_id !== 0 &&
        isEscalated === 0 &&
        hardClose === 0 &&
        ((ticketType === ticketTypes.field && isRmaRaised === 0) || (ticketType === ticketTypes.field && isRmaRaised === 1));

    if (closedByNoc > 0) {
        return showRelease && accepted_sp_id === 0;
    }

    return showRelease;
};

export const isToShowExecuteTicket = (ticket, { role, type, loggedUserId, loggedUserCustomerId }) => {
    const { ticketType, ticket_owned_by, assignToScogo, accepted_fe_id, signOffAccept, isEscalated, isOnHold, hardClose, signOffRequest, po_raised, serviceTypeId } = ticket;
    const ticketServiceTypes = [
        serviceTypeIds.migration,
        serviceTypeIds.reconcile,
        serviceTypeIds.feasibility,
        serviceTypeIds.release_asset,
        serviceTypeIds.scrap_asset,
        serviceTypeIds.asset_replace,
    ];

    let basicCondition = ticketType === 0 && isOnHold === 0 && isEscalated === 0 && hardClose === 0 && po_raised === 0 && !ticketServiceTypes.includes(serviceTypeId);

    const customerCondition = isCustomerGroup(role, type);
    const ujoyCustomerId = 209;

    if (loggedUserCustomerId === ujoyCustomerId) {
        return basicCondition;
    }

    if (!customerCondition) {
        return signOffRequest === 0 && basicCondition;
    }
    if (
        (isScm(role, type) && signOffAccept === 0) ||
        (customerCondition && ticket_owned_by === 1 && assignToScogo === 0) ||
        (loggedUserId === accepted_fe_id && signOffAccept === 0 && !customerCondition)
    ) {
        return basicCondition;
    }
    return false;
};

export const isToShowDigitalForm = (ticket, { role, type, loggedUserId }) => {
    const {
        ticketType,
        ticket_owned_by,
        assignToScogo,
        accepted_fe_id,
        signOffAccept,
        isEscalated,
        isOnHold,
        hardClose,
        signOffRequest,
        po_raised,
        serviceTypeId,
        fk_sign_off_template_id,
    } = ticket;
    const ticketServiceTypes = [
        serviceTypeIds.migration,
        serviceTypeIds.reconcile,
        serviceTypeIds.feasibility,
        serviceTypeIds.release_asset,
        serviceTypeIds.scrap_asset,
        serviceTypeIds.asset_replace,
    ];

    let basicCondition =
        fk_sign_off_template_id > 0 && ticketType === 0 && isOnHold === 0 && isEscalated === 0 && hardClose === 0 && po_raised === 0 && !ticketServiceTypes.includes(serviceTypeId);

    if (!isCustomerGroup(role, type)) {
        return signOffRequest === 0 && basicCondition;
    }
    if (
        (isScm(role, type) && signOffAccept === 0) ||
        (isCustomerGroup(role, type) && ticket_owned_by === 1 && assignToScogo === 0) ||
        (loggedUserId === accepted_fe_id && signOffAccept === 0 && !isCustomerGroup(role, type))
    ) {
        return basicCondition;
    }
    return false;
};

export const isToShowUpdateRmaButton = (ticket, { role, type, loggedUserId }) => {
    const { ticketType, isRmaRaised, assignToScogo, warehouse_owner, cl_rma_response, hardClose, signOffAccept, isOnHold, signOffRequest } = ticket;
    let basicCondition = ticketType === ticketTypes.field && isRmaRaised === 1 && hardClose === 0 && (signOffAccept === 0) && (isOnHold === 0);

    if (signOffRequest === 1) {
        basicCondition = ['', undefined, null].includes(cl_rma_response) && basicCondition;
    }

    if (isScm(role, type)) {
        return basicCondition || warehouse_owner === loggedUserId;
    } else if (isCustomerGroup(role, type)) {
        return basicCondition && assignToScogo === 0;
    } else if (warehouse_owner === loggedUserId) {
        return basicCondition;
    }
    return basicCondition;
};

export const isToShowEditTicket = ({ ticket_owned_by, assignToScogo, signOffAccept, ticketType }, { role, type }) => {
    if (isCustomer(role, type) || isCustomerAdmin(role, type)) {
        return ticket_owned_by === 1 && ticketType === ticketTypes.field;
    }
    if (isScm(role, type)) {
        return (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1)) && signOffAccept === 0;
    }
    return false;
};

export const showSiteComplete = ({ signOffRequest, ticketType, closedByNoc, is_deleted, hardClose }) => {
    return [0, -1].includes(closedByNoc) && ticketType === 0 && signOffRequest === 0 && is_deleted === 0 && hardClose === 0;
};

export const getTicketActions = (role, type, { ticket, loggedUserId, frontend_controller, tab, loggedUserCustomerId }) => {

    const {
        signOffAccept,
        serviceTypeId,
        po_raised,
        is_live_tracking_enabled,
        execution_date,
        reachedSite,
        ticket_owned_by,
        signOffRequest,
        job_sign_off_notes,
        parent_ticket_id,
        assignToScogo,
        accepted_fe_id,
        closedByNoc,
        requestRaised,
        accepted_sp_id,
        fk_assigned_primary_sp_id,
        ticketType,
        signOffReject,
        isEscalated,
        isOnHold,
        hardClose,
        is_deleted,
        sign_off_lock,
        project_allow_ownership
    } = ticket;

    let actions = [
        requestToTrackFE,
        trackFe,
        downloadsAllReport,
        notifyTicketDetailsToEndCustomer,
        editServiceRequest,
        executeTicket,
        updateDigitalForm,
        updateSignOffNotes,
        raisePO,
        shareFeasibilityLink,
        updateRmaDetails,
        updatePo,
        approvePo,
        feasibilityAction,
        addAsset,
        holdTicket,
        resumeTicket,
        addPrice,
        hardCloseTicket,
        siteComplete,
        reAssign,
        assignServiceRequest,
        releaseTicket,
        unlockSignoffAction,
        deleteTicket,
        appointment,

    ];

    actions = actions.filter((action) => {
        if (action.key === siteComplete.key) {
            return (isScm(role, type) || isCluster(role, type)) && showSiteComplete(ticket);
        }

        if (action.key === raisePO.key) {
            return getIsToShowRaisePO(role, type, frontend_controller) && serviceTypeId === serviceTypeIds.feasibility && parent_ticket_id === 0;
        }

        if (action.key === releaseTicket.key) {
            return getIsshowReleaseTicketButton({ role, type, ticket, loggedUserId });
        }

        if (action.key === updateRmaDetails.key) {
            return isToShowUpdateRmaButton(ticket, { role, type, loggedUserId });
        }
        if (action.key === shareFeasibilityLink.key) {
            return (isScm(role, type) || isCluster(role, type) || isCustomerGroup(role, type)) && serviceTypeId === serviceTypeIds.feasibility;
        }
        if (action.key === updatePo.key) {
            return isPoRaised({ po_raised }) && !isIsp(role, type);
        }

        if (action.key === approvePo.key) {
            return getIsToShowApprovePoButton({ ticket, loggedUserId })
        }

        if (action.key === feasibilityAction.key) {
            return getIsEligibleToCloseFeasibility({ ticket }) && tab === ticketChat;
        }

        if (action.key === addAsset.key) {
            return getIsToAddAssetButton(ticket, { role: role, type: type, loggedUserId }) && tab === ticketChat;
        }

        if (action.key === holdTicket.key) {
            return isToShowHoldIcon(ticket) && tab === ticketChat;
        }
        if (action.key === resumeTicket.key) {
            return isToShowResumeIcon(ticket, { role, type }) && tab === ticketChat;
        }
        if (action.key === hardCloseTicket.key) {
            return isShoHardCloseIcon({ signOffRequest }, { role, type }) && tab === ticketChat;
        }

        if (action.key === addPrice.key) {
            return getIsToShowAddNewPrice({ role, type, ticket }) && tab === ticketChat;
        }
        if (action.key === reAssign.key) {
            return (
                isShowReAssign({ requestRaised, assignToScogo, role, type, accepted_sp_id, loggedUserId }) &&
                tab === ticketChat &&
                getIsShowAssignTicketButton({ role, type, ticket, frontend_controller })
            );
        }
        if (action.key === assignServiceRequest.key) {
            return (
                isShowAssign({ requestRaised, role, type, fk_assigned_primary_sp_id }) &&
                tab === ticketChat &&
                getIsShowAssignTicketButton({ role, type, ticket, frontend_controller })
            );
        }

        if (action.key === updateSignOffNotes.key) {
            if (isScm(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type)) return isEligibleForupdatesignoff({ signOffRequest, job_sign_off_notes });
            return false;
        }

        if (action.key === executeTicket.key) {
            if (isCustomerGroup(role, type)) {
                return isToShowExecuteTicket(ticket, { role, type, loggedUserId, loggedUserCustomerId });
            }
            return isToShowExecuteTicket(ticket, { role, type, loggedUserId, loggedUserCustomerId }) && ticket.sign_off_lock !== 1;
        }

        if (action.key === updateDigitalForm.key) {
            return isToShowDigitalForm(ticket, { role, type, loggedUserId });
        }

        if (action.key === downloadsAllReport.key) {
            return showDownloadAssetConfig(ticket, { role, type }) || showDownloadScogoReport(ticket, { role, type });
        }

        if (action.key === deleteTicket.key) {
            return isEligibleForDelete(role, type, { ticket_owned_by, assignToScogo, reachedSite });
        }

        if (action.key === editServiceRequest.key) {
            return isToShowEditTicket({ ticket_owned_by, assignToScogo, signOffAccept, ticketType }, { role, type });
        }

        if (action.key === requestToTrackFE.key) {
            if (isSp(role, type) || isFe(role, type) || isIsp(role, type) || accepted_fe_id === loggedUserId) {
                return false;
            }
            return isEligibleForrequestToTrackFe({ is_live_tracking_enabled, execution_date, reachedSite, ticketType, accepted_fe_id });
        }

        if (action.key === trackFe.key) {
            if (accepted_fe_id === loggedUserId) return false;
            return isEligibleForTrackFe({ is_live_tracking_enabled, execution_date, reachedSite, ticketType });
        }

        if (action.key === unlockSignoffAction.key) {
            return isScm(role, type) && ticket.sign_off_lock === 1;
        }
        if (action.key === appointment.key) {
            return requestRaised !== 0 && ticketType === ticketTypes.field && isScm(role, type) && signOffReject === 0 && isEscalated === 0 && isOnHold === 0 && hardClose === 0 && is_deleted === 0 && closedByNoc === 0 && signOffRequest === 0
        }

        if (action.key === notifyTicketDetailsToEndCustomer.key) {
            return isScm(role, type);
        }

        return true;
    });


    return actions;
};

const downloadTicketReport = {
    key: 'download_ticket_report',
    menuName: 'Ticket Report',
    imgIcon: './img/csvdownload.png',
    onClick: (_, dispatch, { getSelectedTickets = () => { } } = {}) => {
        const tickets = getSelectedTickets();
        let ticket_ids = [];
        if (tickets && tickets.length > 0) {
            ticket_ids = tickets.map((elem) => elem.id);
        };
        const filter = {};
        if (ticket_ids.length > 0) filter.ticket_ids = ticket_ids;
        return dispatch(
            openCustomModal({
                heading: 'Ticket Report',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.TICKET} filterData={filter} />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const downloadExpenseReport = {
    key: 'download_expense_report',
    menuName: 'Expense Report',
    imgIcon: './img/csvdownload.png',

    onClick: (_, dispatch, { getSelectedTickets = () => { } } = {}) => {
        const tickets = getSelectedTickets();
        let ticket_ids = [];
        if (tickets && tickets.length > 0) {
            ticket_ids = tickets.map((elem) => elem.id);
        };
        const filter = {};
        if (ticket_ids.length > 0) filter.ticket_ids = ticket_ids;
        return dispatch(
            openCustomModal({
                heading: 'Expense Report',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.EXPENSE} filterData={filter} />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const downloadWorkflowReport = {
    key: 'download_workflow_report',
    menuName: 'Workflow Report',
    imgIcon: './img/csvdownload.png',

    onClick: (_, dispatch) => {
        openCustomModal({
            heading: 'Workflow Report',
            modalWidth: '40rem',
            modalHeight: 'auto',
            modalComponent: <RequestStatement report={ReportsName.WORKFLOW} filterData={{}} />,
        })
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const downloadTransactionReport = {
    key: 'download_transaction_report',
    menuName: 'Transaction Report',
    imgIcon: './img/csvdownload.png',
    onClick: (_, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Download Transaction Report',
                modalWidth: '50rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.OFFLINE_AND_BANK_TRANSFER_PAYMENTS} filterData={{}} showDateRange />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};


const downloadTicketTransactionsReport = {
    key: 'download_ticket_transactions_report',
    menuName: 'Ticket Transactions Report',
    imgIcon: './img/csvdownload.png',
    onClick: (_, dispatch, { getSelectedTickets = () => { } } = {}) => {
        const tickets = getSelectedTickets();
        let ticket_ids = [];
        if (tickets && tickets.length > 0) {
            ticket_ids = tickets.map((elem) => elem.id);
        };
        const filter = {};
        if (ticket_ids.length > 0) filter.ticket_ids = ticket_ids;
        return dispatch(
            openCustomModal({
                heading: 'Ticket Transactions Report',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.TICKET_TRANSACTIONS} filterData={filter} showDateRange projectRequired={false} />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const BulkdownloadCustomerReport = {
    key: 'bulk_download_customer_report',
    menuName: 'Customer Sign Off Report',
    imgIcon: '/img/zipDownload.png',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        let ticketIds = [];
        let tickets = getSelectedTickets();
        if (tickets.length > 0) {
            if (tickets.length === 0) {
                return dispatch(sendToastMessage({ message: 'Tickets Are Not Eligible For Assign', status: 'warning' }));
            }
            ticketIds = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }

        const filter = {};
        if (ticketIds.length > 0) filter.ticket_ids = ticketIds;
        return dispatch(
            openCustomModal({
                heading: 'Download Customer Sign Off Report',
                modalWidth: '50rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.CUSTOMER_SIGNOFF} filterData={filter} />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const downloadFeasibilityReport = {
    key: 'download_feasibility_report',
    menuName: 'Feasibility Report',
    imgIcon: './img/csvdownload.png',
    onClick: (_, dispatch, { getSelectedTickets = () => { } } = {}) => {
        const tickets = getSelectedTickets();
        let ticket_ids = [];
        if (tickets && tickets.length > 0) {
            ticket_ids = tickets.map((elem) => elem.id);
        };
        const filter = {};
        if (ticket_ids.length > 0) filter.ticket_ids = ticket_ids;
        return dispatch(
            openCustomModal({
                heading: 'Feasibility Report',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.FEASIBILITY} filterData={filter} />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const downloadRmaReport = {
    key: 'download_rma_report',
    menuName: 'RMA Report',
    imgIcon: './img/csvdownload.png',

    onClick: (_, dispatch, { getSelectedTickets = () => { } } = {}) => {
        const tickets = getSelectedTickets();
        let ticket_ids = [];
        if (tickets && tickets.length > 0) {
            ticket_ids = tickets.map((elem) => elem.id);
        };
        return dispatch(
            openCustomModal({
                heading: 'RMA Report',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.RMA} filterData={{ ticket_ids }} />,
            })
        );
    },
    isDisabled: () => {
        return false;
    },
};

const downloadPavReport = {
    key: 'download_pav_report',
    menuName: 'PAV Report',
    imgIcon: './img/csvdownload.png',

    onClick: (_, dispatch, { getSelectedTickets = () => { } } = {}) => {
        const tickets = getSelectedTickets();
        let ticket_ids = [];
        if (tickets && tickets.length > 0) {
            ticket_ids = tickets.map((elem) => elem.id);
        };
        const filter = {};
        if (ticket_ids.length > 0) filter.ticket_ids = ticket_ids;
        return dispatch(
            openCustomModal({
                heading: 'PAV Report',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <RequestStatement report={ReportsName.PAV} filterData={filter} />,
            })
        );
    },
    isDisabled: () => {
        return false;
    },
};

// PAV report for a single ticket, used from the ticket actions menu and the ticket details sidebar.
// The ticket id is the whole filter here, so neither the project dropdown nor the page filters apply.
export const openPavReportModal = (ticket) => {
    return openCustomModal({
        heading: 'PAV Report',
        modalWidth: '60rem',
        modalHeight: 'auto',
        modalComponent: <RequestStatement report={ReportsName.PAV} filterData={{ ticket_ids: [ticket.id] }} showProjectFilter={false} applyPageFilters={false} projectRequired={false} />,
    });
};

const downloadSuperAppFieldReport = {
    key: 'download_super_app_field_report',
    menuName: 'SuperApp Field Report',
    imgIcon: './img/csvdownload.png',

    onClick: (_, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Download SuperApp Field Report',
                modalWidth: '50rem',
                modalHeight: 'auto',
                modalComponent: <DownloadCsv type={2} status='ALL' />,
            })
        );
    },
    isDisabled: () => {
        return false;
    },
};

export const getDownloadReportActions = ({ newLoggedUserData }) => {
    let actions = [downloadTicketReport, downloadRmaReport, downloadPavReport, downloadFeasibilityReport, downloadExpenseReport, BulkdownloadCustomerReport, downloadTransactionReport, downloadTicketTransactionsReport];

    const showDownloadTransacrtionReport = newLoggedUserData.org.type === OrgTypes.CUSTOMER && newLoggedUserData.org.manage_partner_payments;
    const showDownloadTicketTransactionsReport = newLoggedUserData.user.roles.find((elem) => elem.label.toUpperCase() === TicketAgentRole.SCM) && newLoggedUserData.org.id === ScogoID;

    actions = actions.filter((action) => {

        switch (action.key) {
            case downloadTransactionReport.key:
                return showDownloadTransacrtionReport;

            case downloadExpenseReport.key:
                return newLoggedUserData.org.type === OrgTypes.CUSTOMER && newLoggedUserData.org.id === ScogoID;

            case downloadFeasibilityReport.key:
                return newLoggedUserData.org.type === OrgTypes.CUSTOMER && newLoggedUserData.org.id === ScogoID;

            case downloadTicketTransactionsReport.key:
                return showDownloadTicketTransactionsReport;
            default:
                return true;
        }
    });
    return actions;
};



export const getIsToShowAddNewPrice = ({ role, type, ticket }) => {
    const { ticket_owned_by, assignToScogo, signOffAccept } = ticket;
    if (isCustomerGroup(role, type)) {
        return signOffAccept === 0 && ticket_owned_by === 1 && assignToScogo === 0;
    }
    return signOffAccept === 0 && (ticket_owned_by === 0 || (ticket_owned_by === 1 && assignToScogo === 1));
};

const isShowReAssign = ({ requestRaised, assignToScogo, role, type, accepted_sp_id, loggedUserId }) => {
    return requestRaised === 1 || (isCustomerGroup(role, type) && assignToScogo === 1) || isSp(role, type) || (isPsp(role, type) && accepted_sp_id === loggedUserId);
};
const isShowAssign = ({ requestRaised, role, type, fk_assigned_primary_sp_id }) => {
    return ((isCluster(role, type) || isPsp(role, type)) && fk_assigned_primary_sp_id === 0) || (requestRaised === 0 && fk_assigned_primary_sp_id === 0);
};

export const getIsToShowSignOffApproveButton = ({ ticket, loggedUser } = {}) => {
    const frontend_controller = loggedUser.frontend_controller;
    const type = loggedUser.type;
    const role = loggedUser.role.id;
    const {
        signOffAccept,
        ticketType,
        signOffRequest,
        reachedSite,
        accepted_fe_id,
        customerSignOffAccept,
        customerSignOffRequired,
        isEscalated,
        serviceTypeId,
        parent_ticket_id,
        isRmaRaised,
        cl_rma_response,
        po_raised,
    } = ticket;

    let showClAction = ticketType === ticketTypes.support && serviceTypeId === serviceTypeIds.migration;
    let showCloseFeasibility = serviceTypeId === serviceTypeIds.feasibility && parent_ticket_id === 0 && isEscalated === 0;
    let pendingDocketDetail = isPendingDocket(ticket) && signOffRequest === 1;
    let pendingDelivery = isShowPendingDelivery(ticket);
    let isCustomerSignOffRequired =
        (customerSignOffRequired === 0 || customerSignOffRequired === null || (customerSignOffRequired === 1 && customerSignOffAccept === 1)) &&
        [SCM.type, SUPERVISOR.type].includes(type);

    let check =
        isSignOffApproveAllowed(frontend_controller) &&
        po_raised !== 1 &&
        signOffRequest === 1 &&
        accepted_fe_id !== 0 &&
        signOffAccept === 0 &&
        reachedSite === 1 &&
        isEscalated === 0 &&
        !showClAction &&
        !showCloseFeasibility &&
        !pendingDocketDetail &&
        !pendingDelivery &&
        isCustomerSignOffRequired;

    if (isRmaRaised === 1) {
        check = check && !['', undefined, null].includes(cl_rma_response);
    }

    return check && !isSp(role, type) && !isFe(role, type);
};

export const getIsToShowSignOffRejectButton = ({ ticket, loggedUser } = {}) => {
    const frontend_controller = loggedUser.frontend_controller;
    const type = loggedUser.type;
    const role = loggedUser.role.id;
    const {
        signOffAccept,
        ticketType,
        signOffRequest,
        reachedSite,
        accepted_fe_id,
        customerSignOffAccept,
        customerSignOffRequired,
        isEscalated,
        serviceTypeId,
        parent_ticket_id,
        isRmaRaised,
        cl_rma_response,
        po_raised,
    } = ticket;

    let showClAction = ticketType === ticketTypes.support && serviceTypeId === serviceTypeIds.migration;
    let showCloseFeasibility = serviceTypeId === serviceTypeIds.feasibility && parent_ticket_id === 0 && isEscalated === 0;
    let pendingDocketDetail = isPendingDocket(ticket) && signOffRequest === 1;
    let pendingDelivery = isShowPendingDelivery(ticket);

    let check =
        isSignOffApproveAllowed(frontend_controller) &&
        po_raised !== 1 &&
        signOffRequest === 1 &&
        accepted_fe_id !== 0 &&
        signOffAccept === 0 &&
        reachedSite === 1 &&
        isEscalated === 0 &&
        !showClAction &&
        !pendingDelivery &&
        !showCloseFeasibility &&
        !pendingDocketDetail;

    if (isRmaRaised === 1) {
        check = check && !['', undefined, null].includes(cl_rma_response);
    }

    if (isCustomer(role, type) || isCustomerAdmin(role, type) || isCustomerUser(role, type)) {
        return customerSignOffRequired === 1 && customerSignOffAccept === 0 && check;
    }

    return check && !isSp(role, type) && !isFe(role, type);
};

export const getIsCUstomerSignOffApproved = ({ ticket, loggedUser }) => {
    const role = loggedUser.role.id;
    const type = loggedUser.type;
    const {
        signOffAccept,
        ticketType,
        signOffRequest,
        reachedSite,
        accepted_fe_id,
        customerSignOffAccept,
        customerSignOffRequired,
        isEscalated,
        serviceTypeId,
        parent_ticket_id,
        isRmaRaised,
        cl_rma_response,
        po_raised,
        ticket_owned_by,
        assignToScogo,
    } = ticket;

    let showClAction = ticketType === ticketTypes.support && serviceTypeId === serviceTypeIds.migration;
    let showCloseFeasibility = serviceTypeId === serviceTypeIds.feasibility && parent_ticket_id === 0 && isEscalated === 0;
    let pendingDocketDetail = isPendingDocket(ticket) && signOffRequest === 1;
    let pendingDelivery = isShowPendingDelivery(ticket);

    let isCustomerSignOffRequired = (customerSignOffRequired === 1 && customerSignOffAccept === 0) || (ticket_owned_by === 1 && assignToScogo === 0);

    let check =
        po_raised !== 1 &&
        signOffRequest === 1 &&
        accepted_fe_id !== 0 &&
        signOffAccept === 0 &&
        reachedSite === 1 &&
        isEscalated === 0 &&
        !showClAction &&
        !showCloseFeasibility &&
        !pendingDelivery &&
        isCustomerSignOffRequired &&
        !pendingDocketDetail &&
        (isCustomer(role, type) || isCustomerAdmin(role, type));

    if (isRmaRaised === 1) {
        check = check && !['', undefined, null].includes(cl_rma_response);
    }

    return check;
};

export const getIsToShowApproveRejectAssetButton = ({ ticket } = {}) => {
    const { ticketType, isEscalated, serviceTypeId, hardClose, po_raised, signOffAccept } = ticket;
    return ticketType === ticketTypes.support && serviceTypeId === serviceTypeIds.migration && isEscalated === 0 && hardClose === 0 && po_raised !== 1 && signOffAccept === 0;
};

export const getIsEligibleToCloseFeasibility = ({ ticket } = {}) => {
    const { isEscalated, serviceTypeId, parent_ticket_id, po_raised } = ticket;
    return serviceTypeId === serviceTypeIds.feasibility && parent_ticket_id === 0 && isEscalated === 0 && po_raised !== 1;
};

const isPendingDocket = ({
    hard_copy_required,
    hard_copy_received,
    serviceTypeId,
    isEscalated,
    po_raised,
    signOffAccept,
    rltracking_detail,
    signOffRequest,
    is_report_generated,
}) => {
    const basicConditon =
        isEscalated === 0 && po_raised === 0 && signOffAccept === 0 && [null, '', undefined].includes(rltracking_detail) && signOffRequest === 0 && is_report_generated === 1;

    if (hard_copy_required === 1 && hard_copy_received === 0) {
        return basicConditon;
    }
    if (serviceTypeId === serviceTypeIds.reverse_logistics) {
        return basicConditon;
    }
    return false;
};

export const getIsToShowPendingDelivery = ({ ticket, role, type }) => {
    if (isCluster(role, type) || isSuperVisor(role, type) || isScm(role, type)) {
        return isShowPendingDelivery(ticket);
    }
    return false;
};

export const getIsToShowApprovePoButton = ({ ticket, loggedUserId }) => {
    if (ticket.po_raised === 1 && ticket.signOffAccept === 0) {
        let displayPoApproval = false;
        const po = ticket?.po;

        if (po && Array.isArray(po.approvers) && po.approvers.length > 0) {
            displayPoApproval = po.approvers.find((approver) => {
                return approver?.users?.find((userId) => parseInt(userId) === parseInt(loggedUserId) && !approver.closed && approver.authorization)
            })
        }
        if (po && Array.isArray(po.approvals) && po.approvals.length > 0) {
            po.approvals.find((i) => {
                return parseInt(i.userId) === parseInt(loggedUserId)
            });
        }
        return displayPoApproval;
    }
    return false;
};

export const getIsToShowRaisePO = (role, type, frontend_controller) => {
    return isScm(role, type) || (isCustomerGroup(role, type) && isViewPoAllowed(frontend_controller));
};

export const getIsToShowAddNewTicket = ({ frontend_controller, role, type }) => {
    return isTicketAdditionAllowed(frontend_controller) && !isCluster(role, type);
};

export const getIsToAddAssetButton = (ticket, { role, type, loggedUserId }) => {

    const { createdBy } = ticket;
    return isScm(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type) || isCluster(role, type) || createdBy === loggedUserId;

    // const { ticketType, signOffAccept, createdBy, isRmaRaised, serviceTypeId, parent_ticket_id, po_raised } = ticket;
    // //  add this condition when key added ( && isBoqRequired === 1)
    // if ((parent_ticket_id !== 0 && serviceTypeId === 4) || serviceTypeId === 13 || po_raised === 1) return false;
    // return (
    //     ((ticketType === 0 && isRmaRaised === 0) || serviceTypeId === 11) &&
    //     signOffAccept === 0 &&
    //     (isScm(role, type) || isCustomer(role, type) || isCustomerAdmin(role, type) || isCluster(role, type) || createdBy === loggedUserId)
    // );
};

export const getIsToShowReverseDocket = ({ serviceTypeId, hard_copy_required, rltracking_detail, isEscalated, po_raised, signOffAccept, hard_copy_received, signOffRequest }) => {
    if (rltracking_detail) return false;
    return (
        (serviceTypeId === serviceTypeIds.reverse_logistics || (hard_copy_required === 1 && hard_copy_received === 0)) &&
        isEscalated === 0 &&
        po_raised === 0 &&
        signOffAccept === 0 &&
        signOffRequest === 0
    );
};

export const getIsToShowAddDocketButton = ({
    serviceTypeId,
    hard_copy_required,
    rltracking_detail,
    tracking_detail,
    isEscalated,
    po_raised,
    signOffAccept,
    hard_copy_received,
    signOffRequest,
    isRmaRaised,
}) => {
    if ([serviceTypeIds.reconcile, serviceTypeIds.feasibility, serviceTypeIds.scrap_asset, serviceTypeIds.asset_replace].includes(serviceTypeId)) return false;
    if (hard_copy_received === 1) return false;

    const base = isEscalated === 0 && po_raised === 0 && signOffAccept === 0 && signOffRequest === 0;

    if (rltracking_detail && (serviceTypeId === serviceTypeIds.reverse_logistics || (hard_copy_required === 1 && hard_copy_received === 0))) {
        return false;
    }
    if ((rltracking_detail || tracking_detail) && serviceTypeId === serviceTypeIds.migration) return false;

    if ((rltracking_detail || tracking_detail) && isRmaRaised === 1) return false;

    return base;
};


export const getTicketOwner = ({ ticket_owned_by, assign_to_scogo }) => {
    if (ticket_owned_by === 0 || (ticket_owned_by === 1 && assign_to_scogo === 1)) {
        return 'Scogo';
    }
    return 'Customer';
}






// ------------------------------------------New Logic--------------------------------------------

export const deleteServiceRequestAction = {
    key: 'delete_service_request',
    menuName: 'Delete Ticket',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (ticket, dispatch) => {
        let formName = 'deleteTicket';
        let heading = 'Delete Ticket';
        let text = `Are you sure you want to Delete Ticket?`;
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(deleteServiceRequest({ ticketId: ticket.id, formName })),
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        let closeOnBackdropClick = false;

        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName }));
    }
};

const holdServiceRequest = {
    key: 'hold_ticket',
    menuName: 'Hold Ticket',
    menuIcon: 'pause',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const formName = 'hold_ticket_controller';
        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Hold Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: isMobileView ? '35rem' : '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={ticket.org_id} category='HOLD' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {

                let p = { ticketId: ticket.id, state: 'hold' };
                let remark = {};
                if (processed_remark?.value) {
                    remark.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        remark.master_remark_id = processed_remark.value;
                    }
                }
                p.remark = remark;
                dispatch(holdOrResumeServiceRequest({
                    payload: p,
                    formName
                }));
            }
        });
    },
};

const resumeServiceRequest = {
    key: 'resume_ticket',
    menuName: 'Resume Ticket',
    menuIcon: 'play_arrow',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const formName = 'resume';
        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Resume Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={ticket.org_id} category='RESUME' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {
                let p = { ticketId: ticket.id, state: 'resume' };
                let remark = {};
                if (processed_remark?.value) {
                    remark.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        remark.master_remark_id = processed_remark.value;
                    }
                };
                p.remark = remark;
                dispatch(holdOrResumeServiceRequest({
                    payload: p,
                    formName
                }));
            }
        });
    },
};

const hardCloseServiceRequest = {
    key: 'hard_close_service_request',
    menuName: 'Hard Close',
    menuIcon: 'not_interested',
    iconColor: 'text-scogoclosed',
    onClick: (ticket, dispatch) => {
        const milestones = ticket.milestones.filter((mile) => isIndividualMilestoneStatusInRange(mile, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REJECTED));
        let heading = <span className='text-black'>
            Hard Close Ticket :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
        </span>
        let modalComponent = <HardCloseTicket id={ticket.id} milestones={milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = isMobileView ? '35rem' : '50rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
    isDisabled: () => {
        return false;
    },
};

const serviceRequestSiteComplete = {
    key: 'site_complete',
    menuName: 'Site Complete',
    menuIcon: 'domain',
    iconColor: 'text-scogoprimary',

    onClick: (ticket, dispatch) => {
        let heading = 'Site Completed';
        const milestones = ticket.milestones.filter((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REQUESTED));
        const modalComponent = <SiteComplete ticketId={ticket.id} milestones={milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = isMobileView ? '35rem' : '45rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};

const serviceRequestExecutionDate = {
    key: 'execution_date',
    menuName: 'Edit Execution Date',
    menuIcon: 'domain',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        let heading = <span className='text-black'>
            Edit Execution Date :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span>
        </span>;
        const milestones = ticket.milestones.filter((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_ACCEPTED));
        const modalComponent = <ExecutionDate ticketId={ticket.id} milestones={milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = '60rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};

const cloneTicket = {
    key: 'clone_ticket',
    menuName: 'Clone Ticket',
    menuIcon: 'content_copy',
    iconColor: 'text-scogobgsky',
    onClick: (ticket, dispatch) => {
        const formName = 'cloneTicket';
        return dispatch(
            openTextModalAction({
                heading: 'Clone Ticket',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        onClick: () => {
                            dispatch(cloneServiceRequest({ id: ticket.id, formName }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
    isDisabled: (_) => {
        return false;
    },
};


export const TicketStatus = {
    OPEN: 'OPEN',
    TRIGGERED: 'TRIGGERED',
    PLANNED: 'PLANNED',
    IN_PROGRESS: 'IN_PROGRESS',
    ON_HOLD: 'ON_HOLD',
    SIGNOFF_REQUESTED: 'SIGNOFF_REQUESTED',
    CLOSED: 'CLOSED',
    REJECTED: 'REJECTED',
}


export const approveTicketMilestone = {
    key: 'approve_ticket_milestone',
    menuName: 'Approve Ticket Milestone',
    menuIcon: 'check',
    iconColor: 'text-scogobgsky',

    onClick: (ticket, dispatch, { navigate }) => {
        navigate(`/tickets/${ticket.id}/edit-payout?source=ticket&showApproveSignOff=true&heading=Signoff`)
    }
}

const rejectServicerequestMilestone = {
    key: 'reject_ticket_milestone',
    menuName: 'Reject Ticket Milestone',
    menuIcon: 'close',
    iconColor: 'text-scogoclosed',
    onClick: (ticket, dispatch) => {
        const milestones = ticket.milestones.filter((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED, MilestoneSubStatus.SIGN_OFF_REQUESTED));
        let heading = <span className='text-black'>
            Reject Ticket Milestone :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span>
        </span>;
        const modalComponent = <RejectSignOff ticket={ticket} milestones={milestones} />;
        let modalHeight = 'auto',
            modalWidth = '60rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};


export const mapFaultyAsset = {
    key: 'map_faulty_asset',
    menuName: 'Map Faulty Asset',
    menuIcon: 'map',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        let heading = 'Map Faulty Asset';
        const modalComponent = <MapFaultyAsset ticket={ticket} />;
        let modalHeight = 'auto',
            modalWidth = '60rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};

const viewAssetConfig = {
    key: 'view_asset_config',
    menuName: 'View/Edit Config',
    menuIcon: 'visibility',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        dispatch(openCustomModal({
            heading: 'View/Edit Config',
            ...assetConfigModalSize,
            modalComponent: <ViewAssetConfig ticket={ticket} />,
        }));
    },
};


const updateSignOffNotesOfServiceRequest = {
    key: 'update_sign_off_notes_of_service_request',
    menuName: 'Update SignOff Remark',
    menuIcon: 'note_alt',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const findRaisedMilestone = ticket.milestones.filter(milestone => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED)).map(({ id }) => id);
        const milestones = ticket.milestones.filter(({ id, milestone_status }) => findRaisedMilestone.includes(id) && milestone_status !== MilestoneSubStatus.HARD_CLOSED);
        return dispatch(
            openCustomModal({
                heading: 'Update SignOff Remark',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <UpdateSignOffNotes ticketId={ticket.id} milestones={milestones} agents={ticket.agents} />,
            })
        );
    },
};


const assignTicketOwnerShip = {
    key: 'assign_ticket_owner_ship',
    menuName: 'Assign Ticket Ownership',
    menuIcon: 'manage_accounts',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        let heading = (<span className='text-black'>Assign Ticket Ownership</span>);
        return dispatch(
            openCustomModal({
                heading,
                modalWidth: isMobileView ? '35rem' : '60rem',
                modalHeight: 'auto',
                modalComponent: <AssignTicketOwnerShip project_id={ticket.project.id} owners={ticket.attributes.find((elem) => elem.key === 'ticket_owners')?.value || []} ticket_id={ticket.id} org_id={ticket.org_id} />,
            })
        );
    },
};


const assignServiceRequest = {
    key: 'assign_service_request',
    conditionalRendering: (ticket) => {
        if (ticket.milestones && ticket.milestones.find((milestone) => milestone.milestone_status === MilestoneSubStatus.NEW)) {
            return { menuName: 'Assign', menuIcon: 'manage_accounts', iconColor: 'text-scogoprimary' };
        }
        return { menuName: 'Reassign', menuIcon: 'manage_accounts', iconColor: 'text-scogoprimary' };
    },
    onClick: (ticket, dispatch, { loggedUser }) => {
        let heading = (
            <span className='text-black'>
                Assign :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
            </span>
        );
        let modalComponent = <Assign ticket={ticket} />;
        let modalHeight = 'auto',
            modalWidth = isMobileView ? '35rem' : '80rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
    isDisabled: () => {
        return false;
    },
};

const editServiceRequest = {
    key: 'edit_service_request',
    menuName: 'Edit Ticket',
    menuIcon: 'edit',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch, { navigate }) => {
        navigate(`/tickets/${ticket.id}/edit`);
    },
};


const releaseServiceRequest = {
    key: 'release_ticket',
    menuName: 'Release ticket',
    menuIcon: 'lock_reset',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch) => {
        const milestones = ticket.milestones.filter(({ milestone_status }) => milestone_status !== MilestoneSubStatus.HARD_CLOSED);
        let heading = 'Release Ticket';
        const modalComponent = <ReleaseTicket ticketId={ticket.id} milestones={milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = '45rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};


const addMilestoneInServiceRequest = {
    key: 'add_milestone_in_service_request',
    menuName: 'Add New Milestone',
    menuIcon: 'add',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch) => {
        let heading = <span className='text-black'>
            Add New Milestone :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span>
        </span>
        const modalComponent = <AddMilestoneInServiceRequest serviceRequest={ticket} org_id={ticket.org_id} project_id={ticket.project_id} />;
        let modalHeight = 'auto',
            modalWidth = isMobileView ? '35rem' : '80rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};


const assignTechSupportToServiceRequest = {
    key: 'assign_tech_support_to_service_request',
    menuName: 'Assign Tech Support',
    menuIcon: 'support_agent',
    iconColor: 'text-scogoorange',
    onClick: (ticket, dispatch) => {
        let ticketId = ticket.id;
        let heading = (
            <span className='text-black'>
                Assign Tech Support :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span>
            </span>
        );
        const milestones = ticket.milestones.filter(
            ({ milestone_status, type }) =>
                milestone_status !== MilestoneSubStatus.HARD_CLOSED &&
                (
                    type === MilestoneType.REMOTE_SUPPORT ||
                    type === MilestoneType.RMA ||
                    type === MilestoneType.FIELD
                )
        );
        if (milestones.length === 0) {
            return dispatch(sendToastMessage({ message: 'Milestones are not eligible for Assign Tech Support', status: 'warning' }));
        }
        return dispatch(
            openCustomModal({
                heading,
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <AssignTechSupport org_id={ticket.helpdesk_id} ticketId={ticketId} milestones={milestones} agents={ticket.agents} />,
            })
        );
    }
};


const unlockServiceRequestRaiseSignoffAction = {
    key: 'unlock_service_request_signoff',
    menuName: 'Unlock Raise Sign-off',
    menuIcon: 'key',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const milestones = ticket.milestones.filter((milestone) => milestone.is_signoff_locked && milestone.milestone_status !== MilestoneSubStatus.HARD_CLOSED);
        let heading = (
            <span className='text-black'>
                Unlock Raise Sign-off :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
            </span>
        );
        let modalComponent = <UnlockSignoff ticketId={ticket.id} milestones={milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = '40rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
}

const unlockServiceRequestRaiseSignoffApprovalAction = {
    key: 'unlock_service_request_signoff_approval',
    menuName: 'Unlock Sign-off Approval',
    menuIcon: 'key',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const milestones = ticket.milestones.filter((milestone) => milestone.is_signoff_locked && milestone.milestone_status !== MilestoneSubStatus.HARD_CLOSED);
        let heading = (
            <span className='text-black'>
                Unlock Sign-off Approval :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
            </span>
        );
        let modalComponent = <UnlockSignoff ticketId={ticket.id} milestones={milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = '50rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
}


const customerApprovalRecievedServiceRequest = {
    key: 'customer_approval_recieved',
    menuName: 'Customer Billing Received',
    menuIcon: 'receipt',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const heading = <span>Customer Billing Received :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span></span>;
        dispatch(openCustomModal({ modalComponent: <BillingApproval tickets={[ticket]} mode='received' />, heading, modalWidth: '70rem', modalHeight: 'auto' }));
    }
};

const customerBillingSubmittedServiceRequest = {
    key: 'customer_billing_submitted',
    menuName: 'Customer Billing Submitted',
    menuIcon: 'send',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch) => {
        const heading = <span>Customer Billing Submitted :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span></span>;
        dispatch(openCustomModal({ modalComponent: <BillingApproval tickets={[ticket]} mode='submitted' />, heading, modalWidth: '70rem', modalHeight: 'auto' }));
    },
};

const customerBillingRejectedServiceRequest = {
    key: 'customer_billing_rejected',
    menuName: 'Customer Billing Rejected',
    menuIcon: 'cancel',
    iconColor: 'text-scogoclosed',
    onClick: (ticket, dispatch) => {
        const heading = <span>Customer Billing Rejected :&nbsp;<span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span></span>;
        dispatch(openCustomModal({ modalComponent: <BillingApproval tickets={[ticket]} mode='rejected' />, heading, modalWidth: '70rem', modalHeight: 'auto' }));
    },
};

const revokeCustomerApprovalServiceRequest = {
    key: 'revoke_customer_approval',
    menuName: 'Revoke Customer Approval',
    menuIcon: 'undo',
    iconColor: 'text-scogoclosed',
    onClick: (ticket, dispatch) => {
        let heading = <span className=''>
            <span className={`${isMobileView ? 'text-font12' : 'text-font18'}`}>Revoke Customer Approval :</span><span className='text-scogobgsky text-font16'>{ticket.ticket_number}</span>
        </span>;
        dispatch(openCustomModal({ modalComponent: <RevokeBillingApproval tickets={[ticket]} />, heading, modalWidth: '70rem', modalHeight: 'auto' }));
    }
};


const customerApprovalTicketServiceRequest = {
    key: 'approve_ticket',
    menuName: 'Approve Ticket',
    menuIcon: 'done',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch, { onBack } = {}) => {
        const milestones = ticket.milestones.filter((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED, MilestoneSubStatus.SIGN_OFF_REQUESTED) && (milestone.is_signoff_locked === false || isPavMilestoneSignOffUnlocked(milestone)));
        let heading = (
            <span className='text-black'>
                Approve Ticket :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
            </span>
        );
        let modalComponent = <CustomerApproveRejectSignOff ticket={ticket} milestones={milestones} status='CUSTOMER_SIGN_OFF_ACCEPTED' onBack={onBack} />;
        let modalHeight = 'auto',
            modalWidth = '50rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};

const customerRejectionTicketServiceRequest = {
    key: 'reject_ticket',
    menuName: 'Reject Ticket',
    menuIcon: 'close',
    iconColor: 'text-scogoprimary',
    onClick: (ticket, dispatch, { onBack } = {}) => {
        const milestones = ticket.milestones.filter((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED, MilestoneSubStatus.SIGN_OFF_REQUESTED) && (milestone.is_signoff_locked === false || isPavMilestoneSignOffUnlocked(milestone)));
        let heading = (
            <span className='text-black'>
                Reject Ticket :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
            </span>
        );
        let modalComponent = <CustomerApproveRejectSignOff ticket={ticket} milestones={milestones} status='CUSTOMER_SIGN_OFF_REJECTED' onBack={onBack} />;
        let modalHeight = 'auto',
            modalWidth = '50rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    }
};

export const TicketMilestoneEvents = {
    // Ticket Events
    CREATED: 'ticket.created',
    AGENTS_ADDED: 'ticket.agents.added',
    AGENTS_REMOVED: 'ticket.agents.removed',
    TEAMS_ADDED: 'ticket.teams.added',
    TEAMS_REMOVED: 'ticket.teams.removed',
    UPDATED: 'ticket.updated',
    STATUS_CHANGED: 'ticket.status.changed',
    PRIORITY_CHANGED: 'ticket.priority.changed',
    ARCHIVED: 'ticket.archived',
    UNARCHIVED: 'ticket.unarchived',
    DELETED: 'ticket.deleted',
    HOLD: 'ticket.hold',
    RESUME: 'ticket.resume',
    BULK_CHANGE_STATE: 'ticket.bulk.state',
    HARD_CLOSE: 'ticket.hardclose',
    CLOSED: 'ticket.closed',
    EXECUTION_DATE_UPDATED: 'ticket.milestone.execution.date.updated',
    HELPDESK_ASSIGNED: 'ticket.helpdesk.assigned',
    ADD_TO_CLICKHOUSE: 'ticket.clickhouse.add',
    ADD_OFFLINE_PAYMENT: 'ticket.offline.payment.add',
    REMARK_ADDED: 'ticket.remark.added',
    VENDOR_RELEASED: 'cloud.ticket.milestone.vendor.released',

    INBOUND_MISSED: 'ticket.inbound.missed',
    INBOUND_ANSWERED: 'ticket.inbound.answered',

    // Milestone Events
    MILESTONE_CREATED: 'ticket.milestone.created',
    MILESTONE_UPDATED: 'ticket.milestone.updated',
    MILESTONE_DELETED: 'ticket.milestone.deleted',
    MILESTONE_BROADCASTED: 'ticket.milestone.broadcasted',
    MILESTONE_ACCEPTED: 'ticket.milestone.accepted',
    MILESTONE_SITE_COMPLETED: 'ticket.milestone.site.completed',
    MILESTONE_SIGN_OFF_REQUESTED: 'ticket.milestone.signoff.requested',
    MILESTONE_SIGN_OFF_ACCEPTED: 'ticket.milestone.signoff.accepted',
    MILESTONE_SIGN_OFF_REJECTED: 'ticket.milestone.signoff.rejected',
    MILESTONE_ENGINEER_AT_SITE: 'ticket.milestone.engineer.at.site',
    MILESTONE_ENGINEER_LEFT_SITE: 'ticket.milestone.engineer.left.site',
    MILESTONE_TRACKING_REQUESTED: 'ticket.milestone.tracking.requested',
    MILESTONE_ENGINEER_ON_THE_WAY: 'ticket.milestone.tracking.engineer.on.the.way',
    MILESTONE_INSURANCE_REQUESTED: 'ticket.milestone.insurance.requested',
    MILESTONE_FIELD_ASSIGNED: 'ticket.milestone.field.assigned',
    MILESTONE_TRACKING_DISABLED: 'ticket.milestone.tracking.disabled',
    MILESTONE_NO_RESPONSE: 'cloud.ticket.milestone.event.no-response',
    MILESTONE_MAP_FAULTY_ASSET: 'inventory.asset.map_faulty_asset',
    MILESTONE_ADD_BOQ: 'inventory.asset.add_boq',
    MILESTONE_UPDATE_RMA: 'inventory.asset.update_rma',
};


export const TicketMilestoneEventLabels = {
    // Ticket Event Labels
    [TicketMilestoneEvents.CREATED]: 'Ticket Created',
    [TicketMilestoneEvents.AGENTS_ADDED]: 'Agents Added',
    [TicketMilestoneEvents.AGENTS_REMOVED]: 'Agents Removed',
    [TicketMilestoneEvents.TEAMS_ADDED]: 'Teams Added',
    [TicketMilestoneEvents.TEAMS_REMOVED]: 'Teams Removed',
    [TicketMilestoneEvents.UPDATED]: 'Ticket Updated',
    [TicketMilestoneEvents.STATUS_CHANGED]: 'Status Changed',
    [TicketMilestoneEvents.PRIORITY_CHANGED]: 'Priority Changed',
    [TicketMilestoneEvents.ARCHIVED]: 'Ticket Archived',
    [TicketMilestoneEvents.UNARCHIVED]: 'Ticket Unarchived',
    [TicketMilestoneEvents.DELETED]: 'Ticket Deleted',
    [TicketMilestoneEvents.HOLD]: 'Ticket On Hold',
    [TicketMilestoneEvents.RESUME]: 'Ticket Resumed',
    [TicketMilestoneEvents.BULK_CHANGE_STATE]: 'Bulk State Changed',
    [TicketMilestoneEvents.HARD_CLOSE]: 'Ticket Hard Closed',
    [TicketMilestoneEvents.CLOSED]: 'Ticket Closed',
    [TicketMilestoneEvents.EXECUTION_DATE_UPDATED]: 'Execution Date Updated',
    [TicketMilestoneEvents.HELPDESK_ASSIGNED]: 'Helpdesk Assigned',
    [TicketMilestoneEvents.ADD_TO_CLICKHOUSE]: 'Added To Clickhouse',
    [TicketMilestoneEvents.ADD_OFFLINE_PAYMENT]: 'Offline Payment Added',
    [TicketMilestoneEvents.REMARK_ADDED]: '',

    // Milestone Event Labels
    [TicketMilestoneEvents.MILESTONE_CREATED]: 'Milestone Created',
    [TicketMilestoneEvents.MILESTONE_UPDATED]: 'Milestone Updated',
    [TicketMilestoneEvents.MILESTONE_DELETED]: 'Milestone Deleted',
    [TicketMilestoneEvents.MILESTONE_BROADCASTED]: 'Milestone Broadcast',
    [TicketMilestoneEvents.MILESTONE_ACCEPTED]: 'Milestone Accepted',
    [TicketMilestoneEvents.MILESTONE_SITE_COMPLETED]: 'Site Completed',
    [TicketMilestoneEvents.MILESTONE_SIGN_OFF_REQUESTED]: 'Sign Off Requested',
    [TicketMilestoneEvents.MILESTONE_SIGN_OFF_ACCEPTED]: 'Sign Off Accepted',
    [TicketMilestoneEvents.MILESTONE_SIGN_OFF_REJECTED]: 'Sign Off Rejected',
    [TicketMilestoneEvents.MILESTONE_ENGINEER_AT_SITE]: 'Engineer At Site',
    [TicketMilestoneEvents.MILESTONE_ENGINEER_LEFT_SITE]: 'Engineer Left Site',
    [TicketMilestoneEvents.MILESTONE_TRACKING_REQUESTED]: 'Tracking Requested',
    [TicketMilestoneEvents.MILESTONE_ENGINEER_ON_THE_WAY]: 'Engineer On The Way',
    [TicketMilestoneEvents.MILESTONE_INSURANCE_REQUESTED]: 'Insurance Requested',
    [TicketMilestoneEvents.MILESTONE_FIELD_ASSIGNED]: 'Field Assigned',
    [TicketMilestoneEvents.MILESTONE_TRACKING_DISABLED]: 'Tracking Disabled',
    [TicketMilestoneEvents.MILESTONE_MAP_FAULTY_ASSET]: 'Map Faulty Asset',
    [TicketMilestoneEvents.MILESTONE_ADD_BOQ]: 'Add BOQ',
    [TicketMilestoneEvents.MILESTONE_UPDATE_RMA]: 'Update RMA',
    [TicketMilestoneEvents.MILESTONE_NO_RESPONSE]: 'No Response',

    [TicketMilestoneEvents.INBOUND_MISSED]: 'Call Missed',
    [TicketMilestoneEvents.INBOUND_ANSWERED]: 'Call Answered',
};



export const MilestoneSubStatus = {
    NEW: 'NEW',
    REMOTE_ASSIGNED: "REMOTE_ASSIGNED",
    FIELD_ASSIGNED: "FIELD_ASSIGNED",
    BROADCASTED: "BROADCASTED",
    FIELD_ACCEPTED: "FIELD_ACCEPTED",
    TRACKING_REQUESTED: 'TRACKING_REQUESTED',
    ENGINEER_ON_THE_WAY: 'ENGINEER_ON_THE_WAY',
    ENGINEER_AT_SITE: "ENGINEER_AT_SITE",
    ENGINEER_LEFT_SITE: 'ENGINEER_LEFT_SITE',
    SITE_COMPLETED: 'SITE_COMPLETED',
    SIGN_OFF_REQUESTED: 'SIGN_OFF_REQUESTED',
    CUSTOMER_SIGN_OFF_ACCEPTED: 'CUSTOMER_SIGN_OFF_ACCEPTED',
    CUSTOMER_SIGN_OFF_REJECTED: 'CUSTOMER_SIGN_OFF_REJECTED',
    SIGN_OFF_REJECTED: 'SIGN_OFF_REJECTED',
    SIGN_OFF_ACCEPTED: 'SIGN_OFF_ACCEPTED',
    HARD_CLOSED: 'HARD_CLOSED',
}

export const MilestoneSubStatusOrder = {
    NEW: 0,
    REMOTE_ASSIGNED: 1,
    FIELD_ASSIGNED: 2,
    BROADCASTED: 3,
    FIELD_ACCEPTED: 4,
    TRACKING_REQUESTED: 5,
    ENGINEER_ON_THE_WAY: 6,
    ENGINEER_AT_SITE: 7,
    ENGINEER_LEFT_SITE: 8,
    SITE_COMPLETED: 9,
    SIGN_OFF_REQUESTED: 10,
    CUSTOMER_SIGN_OFF_ACCEPTED: 11,
    CUSTOMER_SIGN_OFF_REJECTED: 12,
    SIGN_OFF_REJECTED: 13,
    SIGN_OFF_ACCEPTED: 14,
    HARD_CLOSED: 15,
}

export const TicketStatusOrder = {
    OPEN: 1,
    TRIGGERED: 2,
    PLANNED: 3,
    IN_PROGRESS: 4,
    ON_HOLD: 5,
    SIGNOFF_REQUESTED: 6,
    CLOSED: 7,
}

export const TicketAgentRole = {
    CUSTOMER: 'CUSTOMER',
    CLUSTER: 'CLUSTER',
    PSP: 'PSP',
    SUPERVISOR: 'SUPERVISOR',
    SP: 'SP',
    SCM: 'SCM',
    FE: 'FE',
    PM: 'PM',
    PM1: 'PM1',
    PM2: 'PM2',
    PM3: 'PM3',
    EM: 'EM',
    REQUESTER: 'REQUESTER',
    AGENT: 'AGENT',
    REMOTE_SUPPORT: 'REMOTE_SUPPORT',
    WAREHOUSE_OWNER: 'WAREHOUSE_OWNER'
};

export const MilestoneType = {
    REMOTE_SUPPORT: 'REMOTE_SUPPORT',
    FIELD: 'FIELD',
    INSTALLATION: 'INSTALLATION',
    RMA: 'RMA',
    LOGISTICS: 'LOGISTICS',
}


export const TicketActionsEnum = {
    EDIT_TICKET: 'EDIT_TICKET',  // done
    DELETE_TICKET: 'DELETE_TICKET', // done
    BROADCAST_TICKET: 'BROADCAST_TICKET', // done
    ASSIGN_TICKET: 'ASSIGN_TICKET', // done
    APPROVE_AMOUNT_TICKET: 'APPROVE_AMOUNT_TICKET', // done
    APPROVE_SIGNOFF_TICKET: 'APPROVE_SIGNOFF_TICKET', // done
    MODIFY_AMOUNT_TICKET: 'MODIFY_AMOUNT_TICKET', // done
    VIEW_CUSTOMER_BILLING_TICKET: 'VIEW_CUSTOMER_BILLING_TICKET',
    ROLLBACK_AMOUNT_TICKET: 'ROLLBACK_AMOUNT_TICKET',
    VIEW_INCENTIVE_TICKET: 'VIEW_INCENTIVE_TICKET',
    BANK_TRANSFER_TICKET: 'BANK_TRANSFER_TICKET',
    ACCEPT_ASSET: 'ACCEPT_ASSET',
    REJECT_ASSET: 'REJECT_ASSET',
    UPDATE_RMA: 'UPDATE_RMA',
    MODIFY_EXECUTION_DATE: 'MODIFY_EXECUTION_DATE',
    HOLD_RESUME: 'HOLD_RESUME',
    VIEW_BUDGET: 'VIEW_BUDGET'
}

export const isIndividualMilestoneStatusInRange = (milestone, lowerBound, upperBound) => {
    const statusOrder = MilestoneSubStatusOrder[milestone?.milestone_status];
    const lowerOrder = lowerBound ? MilestoneSubStatusOrder[lowerBound] : -Infinity;
    const upperOrder = upperBound ? MilestoneSubStatusOrder[upperBound] : Infinity;
    return statusOrder <= upperOrder && statusOrder >= lowerOrder;
}

export const isMilestoneStatusInRange = (milestones, lowerBound, upperBound) => {
    return milestones.some(milestone => {
        const statusOrder = MilestoneSubStatusOrder[milestone?.milestone_status];
        const lowerOrder = lowerBound ? MilestoneSubStatusOrder[lowerBound] : -Infinity;
        const upperOrder = upperBound ? MilestoneSubStatusOrder[upperBound] : Infinity;
        return statusOrder <= upperOrder && statusOrder >= lowerOrder;
    });
};

export const isTicketStatusInRange = (ticketStatus, lowerBound, upperBound) => {
    const statusOrder = TicketStatusOrder[ticketStatus];
    const lowerOrder = lowerBound ? TicketStatusOrder[lowerBound] : -Infinity;
    const upperOrder = upperBound ? TicketStatusOrder[upperBound] : Infinity;
    return statusOrder < upperOrder && statusOrder >= lowerOrder;
};

// Assign Tech Support
const eligibleForAssignTechSupport = (milestones, ticket_status) => {
    const findRemoteSupport = milestones.find((mile) => [MilestoneType.REMOTE_SUPPORT, MilestoneType.RMA, MilestoneType.FIELD].includes(mile.type));
    if (!findRemoteSupport) return false;
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REQUESTED) && ticket_status !== TicketStatus.CLOSED && ticket_status !== TicketStatus.ON_HOLD;
}


export const canUpdateRma = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.UPDATE_RMA);
    return (!hasPermission || hasPermission && hasPermission.allowed);
}
// Map Faulty Asset
export const eligibleForMapFaultyAsset = (milestones, ticket_status, actions) => {
    let type = milestones.find(milestone => milestone.type === MilestoneType.RMA && (!milestone?.rma?.faulty_asset_id || !milestone?.rma?.faulty_asset_id?.length));
    if (!type) return false;
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_ACCEPTED) && ticket_status !== TicketStatus.CLOSED && ticket_status !== TicketStatus.ON_HOLD;
}

// Update RMA Details
export const eligibleForUpdateRmaDetails = (milestones, ticket_status, actions) => {
    milestones = milestones.filter(milestone => milestone.type === MilestoneType.RMA);
    if (!milestones.length) return false;
    let type = milestones.find(milestone => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REJECTED) && (!milestone?.rma?.spare_asset_id || !milestone?.rma?.spare_asset_id?.length) && milestone?.rma?.status !== 'completed');
    if (!type) return false;
    return ticket_status !== TicketStatus.CLOSED && ticket_status !== TicketStatus.ON_HOLD;
}

export const eligibleForEditRmaDetails = (milestones, ticket_status, actions) => {
    milestones = milestones.filter(milestone => milestone.type === MilestoneType.RMA);
    let type = milestones.find(milestone => milestone.type === MilestoneType.RMA && (milestone?.rma?.spare_asset_id || milestone?.rma?.faulty_asset_id));
    if (!type) return false;
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REJECTED) && ticket_status !== TicketStatus.CLOSED;
}

// Approve Ticket Milestone
export const canApproveSignOffTicket = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.APPROVE_SIGNOFF_TICKET);
    return (!hasPermission || hasPermission && hasPermission.allowed);
};

export const eligibleForApproveTicketMilestone = (milestones, ticket_status, actions, is_customer_sign_off_required, org_id, logged_user_org_id) => {
    return canApproveSignOffTicket(actions) && isMilestoneStatusInRange(milestones, is_customer_sign_off_required && org_id !== logged_user_org_id ? MilestoneSubStatus.CUSTOMER_SIGN_OFF_ACCEPTED : MilestoneSubStatus.SIGN_OFF_REQUESTED, is_customer_sign_off_required && org_id !== logged_user_org_id ? MilestoneSubStatus.CUSTOMER_SIGN_OFF_ACCEPTED : MilestoneSubStatus.SIGN_OFF_REQUESTED) && ticket_status !== TicketStatus.CLOSED;
};

// Site Complete
export const eligibleForSiteComplete = (milestones, ticket_status) => {
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.ENGINEER_AT_SITE) && ticket_status !== TicketStatus.CLOSED && ticket_status !== TicketStatus.ON_HOLD;
};

// Resume Service Request
export const eligibleForResumeServiceRequest = (milestones, ticket_status) => {
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REQUESTED) && ticket_status === TicketStatus.ON_HOLD && ticket_status !== TicketStatus.CLOSED;
}

// Hold Service Request
export const eligibleForHoldServiceRequest = (milestones, ticket_status) => {
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REQUESTED) && ticket_status !== TicketStatus.ON_HOLD && ticket_status !== TicketStatus.CLOSED;
}

// Hard Close Service Request
export const eligibleForHardCloseServiceRequest = (milestones, ticket_status) => {
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REJECTED) && ticket_status !== TicketStatus.CLOSED;
}

// Service Request Execution Date
export const eligibleForServiceRequestExecutionDate = (ticket) => {
    return canModifyExecutionDate(ticket) && isMilestoneStatusInRange(ticket.milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_ACCEPTED) && ticket.status !== TicketStatus.CLOSED && ticket.status !== TicketStatus.ON_HOLD;
}

export const eligibleForDeleteServiceRequestAction = (ticket_status, actions = []) => {
    if (!actions) return false;
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.DELETE_TICKET)
    return (!hasPermission || hasPermission && hasPermission.allowed) && isTicketStatusInRange(ticket_status, TicketStatus.OPEN, TicketStatus.IN_PROGRESS);
}


// Assign
export const eligibleForAssign = (ticket) => {
    if (!ticket.actions) return false;
    if (ticket.category && typeof ticket.category === 'string' && ticket.category.toLowerCase().includes('migration')) {
        return false;
    }
    const isActionAllowed = ticket.actions.find(({ action }) => action === TicketActionsEnum.ASSIGN_TICKET);
    if (isActionAllowed && isActionAllowed.allowed === false) return false;
    if (ticket.helpdesk_id !== ScogoID) {
        return true;
    }
    return isMilestoneStatusInRange(ticket.milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.ENGINEER_LEFT_SITE) && ticket.status !== TicketStatus.CLOSED && ticket.status !== TicketStatus.ON_HOLD;
}

// Add Additional Amount
export const eligibleToAddAdditionalAmount = (milestones, ticket_status, org_type, org_id) => {
    let check = isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_ACCEPTED);
    if (org_id === ScogoID) {
        return check && ticket_status !== TicketStatus.CLOSED;
    }
    if (org_type !== OrgTypes.CUSTOMER) {
        return check = check && ticket_status !== TicketStatus.CLOSED;
    }
    return check;
};

// Update SignOff Notes
export const eligibleForUpdateSignOffNotesOfServiceRequest = (milestones, ticket_status) => {
    const findRaisedMilestone = milestones.filter(milestone => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED)).map(({ id }) => id);
    return findRaisedMilestone && findRaisedMilestone.length > 0 && isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REQUESTED);
}

// Reached Site
export const eligibleForReachedSite = (milestones, ticket_status) => {
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.NEW, MilestoneSubStatus.ENGINEER_AT_SITE);
}

export const eligibleForChecklist = (milestones, ticket_status) => {
    return isMilestoneStatusInRange(milestones, MilestoneSubStatus.ENGINEER_AT_SITE);
}

export const eligibleForAddDocketDetails = ({ milestones, status }) => {
    return milestones.find((milestone) => milestone.type === MilestoneType.LOGISTICS) && status !== TicketStatus.CLOSED && status !== TicketStatus.ON_HOLD;
}


///// HELPER FUNCTIONS FOR TICKETS API PERMISSIONS /////

export const canModifyExecutionDate = ({ actions = [], status }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.MODIFY_EXECUTION_DATE);
    return (!hasPermission || hasPermission && hasPermission.allowed) && status !== TicketStatus.CLOSED && status !== TicketStatus.ON_HOLD;
}

export const canEditTicket = (ticket) => {
    if (!ticket.actions) return false;
    const hasPermission = ticket.actions.find(({ action }) => action === TicketActionsEnum.EDIT_TICKET);
    return (hasPermission && hasPermission.allowed) && ticket.status !== TicketStatus.CLOSED;
};

export const canHoldOrResumeTicket = (ticket) => {
    if (!ticket.actions) return false;
    const hasPermission = ticket.actions.find(({ action }) => action === TicketActionsEnum.HOLD_RESUME);
    return (hasPermission && hasPermission.allowed) && ticket.status !== TicketStatus.CLOSED;
};


export const canAddAsset = (ticket) => {
    if (!ticket.actions) return false;
    const hasPermission = ticket.actions.find(({ action }) => action === TicketActionsEnum.EDIT_TICKET);
    return (hasPermission && hasPermission.allowed) && ticket.status !== TicketStatus.ON_HOLD;
};

export const canBroadcastTicket = (ticket) => {
    const hasPermission = ticket.actions.find(({ action }) => action === TicketActionsEnum.BROADCAST_TICKET);
    return (hasPermission && hasPermission.allowed) && ticket.status !== TicketStatus.CLOSED && ticket.status !== TicketStatus.ON_HOLD;
}

export const canApproveAmountTicket = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.APPROVE_AMOUNT_TICKET);
    return (hasPermission && hasPermission.allowed);
}

export const canModifyAmountTicket = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.MODIFY_AMOUNT_TICKET);
    return (hasPermission && hasPermission.allowed);
}

export const canViewCustomerBillingTicket = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.VIEW_CUSTOMER_BILLING_TICKET);
    return (hasPermission && hasPermission.allowed);
}

export const canRollbackAmountTicket = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.ROLLBACK_AMOUNT_TICKET);
    return (hasPermission && hasPermission.allowed);
}

export const canViewIncentiveTicket = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.VIEW_INCENTIVE_TICKET);
    return (hasPermission && hasPermission.allowed);
}

export const canBankTransferTicket = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.BANK_TRANSFER_TICKET);
    return (hasPermission && hasPermission.allowed);
}

export const canAcceptAsset = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.ACCEPT_ASSET);
    return (hasPermission && hasPermission.allowed);
}

export const canRejectAsset = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.REJECT_ASSET);
    return (hasPermission && hasPermission.allowed);
}

export const canViewBudgetTicket = ({ actions = [] }) => {
    const hasPermission = actions.find(({ action }) => action === TicketActionsEnum.VIEW_BUDGET);
    return (hasPermission && hasPermission.allowed);
}

///// HELPER FUNCTIONS FOR TICKETS API PERMISSIONS /////

const getPavRaiseSignoffActions = (ticket) => {
    const pavMilestones = (Array.isArray(ticket?.milestones) ? ticket.milestones : []).filter((milestone) => (
        canRaisePavMilestoneSignOff({
            ticket,
            milestone,
        })
    ));

    if (pavMilestones.length === 0) return [];

    return [{
        key: 'raise_pav_signoff',
        menuName: 'Raise PAV Signoff',
        menuIcon: 'assignment_turned_in',
        iconColor: 'text-scogoprimary',
        onClick: (_, dispatch) => {
            dispatch(openCustomModal({
                heading: 'Raise PAV Signoff',
                modalHeight: 'auto',
                modalWidth: isMobileView ? '90vw' : '50rem',
                modalComponent: <RaisePavSignOff ticket={ticket} milestones={pavMilestones} />,
            }));
        },
    }];
};

// Milestone-wise physical verification of the PAV assets and their attachments.
// SCM and customer users get it, and only on tickets with a PAV milestone.
const getPavPhysicalVerificationActions = (ticket, user) => {
    const pavMilestones = (Array.isArray(ticket?.milestones) ? ticket.milestones : []).filter(isPavMilestone);
    if (pavMilestones.length === 0 || !canVerifyPavAssets(user, ticket.org_id)) return [];

    return [{
        key: 'pav_asset_physical_verification',
        menuName: 'PAV Asset Verification',
        menuIcon: 'fact_check',
        iconColor: 'text-scogoprimary',
        onClick: (_, dispatch) => {
            dispatch(openCustomModal({
                heading: (
                    <span className='text-black'>
                        PAV Asset Verification :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
                    </span>
                ),
                modalWidth: 'min(82rem, 95vw)',
                modalHeight: 'auto',
                maxHeight: '80vh',
                modalComponent: <PavPhysicalVerification ticket={ticket} />,
            }));
        },
    }];
};


// PAV report request for this ticket alone, only on tickets that actually have a PAV milestone.
const getPavReportActions = (ticket) => {
    const hasPavMilestone = (Array.isArray(ticket?.milestones) ? ticket.milestones : []).some(isPavMilestone);
    if (!hasPavMilestone) return [];

    return [{
        key: 'download_ticket_pav_report',
        menuName: 'PAV Report',
        menuIcon: 'download',
        iconColor: 'text-scogoprimary',
        onClick: (_, dispatch) => {
            dispatch(openPavReportModal(ticket));
        },
    }];
};

export const getTicketActionsList = (ticket, user) => {
    if (!ticket || Object.keys(ticket).length === 0) return [];
    let maxActions = [viewAssetConfig, approveTicketMilestone, rejectServicerequestMilestone, customerApprovalTicketServiceRequest, customerRejectionTicketServiceRequest, editServiceRequest, unlockServiceRequestRaiseSignoffAction, unlockServiceRequestRaiseSignoffApprovalAction, assignServiceRequest, releaseServiceRequest, cloneTicket, assignTicketOwnerShip, addMilestoneInServiceRequest, mapFaultyAsset, assignTechSupportToServiceRequest, serviceRequestSiteComplete, serviceRequestExecutionDate, resumeServiceRequest, holdServiceRequest, hardCloseServiceRequest, deleteServiceRequestAction, updateRmaDetails, updateSignOffNotesOfServiceRequest, customerBillingSubmittedServiceRequest, customerApprovalRecievedServiceRequest, customerBillingRejectedServiceRequest, revokeCustomerApprovalServiceRequest];

    const isScogoMember = user.orgMemberships.find(({ id }) => id === ScogoID);
    const org_membership_ids = user.orgMemberships.map(({ id }) => id);
    const milestonesToCheck = ticket.milestones ? ticket.milestones.filter((milestone) => ![MilestoneSubStatus.SIGN_OFF_REJECTED, MilestoneSubStatus.HARD_CLOSED].includes(milestone.milestone_status) && (milestone.is_signoff_locked === false || isPavMilestoneSignOffUnlocked(milestone))) : [];
    maxActions = [...getPavPhysicalVerificationActions(ticket, user), ...getPavRaiseSignoffActions(ticket), ...getPavReportActions(ticket), ...maxActions];

    maxActions = maxActions.filter(({ key }) => {
        switch (key) {
            case assignServiceRequest.key:    // Assign
                return eligibleForAssign(ticket);

            case releaseServiceRequest.key: {
                return eligibleForAssign(ticket) && ticket.agents.find((a) => a.role === TicketAgentRole.SP);
            }

            case serviceRequestExecutionDate.key:    // Execution Date
                return eligibleForServiceRequestExecutionDate(ticket);

            case mapFaultyAsset.key:    // Map Faulty Asset
                return eligibleForMapFaultyAsset(ticket.milestones, ticket.status, ticket.actions);

            case updateRmaDetails.key:    // Update RMA Details
                return eligibleForUpdateRmaDetails(ticket.milestones, ticket.status, ticket.actions);

            case approveTicketMilestone.key: {
                let check = canApproveSignOffTicket(ticket.actions) && org_membership_ids.includes(ticket.helpdesk_id) && ![TicketStatus.CLOSED, TicketStatus.ON_HOLD].includes(ticket.status) && milestonesToCheck.find((milestone) => {
                    if (ticket.is_customer_sign_off_required === true && ticket.helpdesk_id === ScogoID) {
                        return isIndividualMilestoneStatusInRange(
                            milestone,
                            MilestoneSubStatus.CUSTOMER_SIGN_OFF_ACCEPTED,
                            MilestoneSubStatus.SIGN_OFF_ACCEPTED
                        );
                    } else {
                        return isIndividualMilestoneStatusInRange(
                            milestone,
                            MilestoneSubStatus.SIGN_OFF_REQUESTED,
                            MilestoneSubStatus.SIGN_OFF_ACCEPTED
                        );
                    }
                })
                return check;
            }

            case rejectServicerequestMilestone.key: {
                const milestones = ticket.milestones.filter((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED, MilestoneSubStatus.SIGN_OFF_REQUESTED));
                if (milestones.length === 0) return false;
                if (eligibleForApproveTicketMilestone(ticket.milestones, ticket.status, ticket.actions, ticket.is_customer_sign_off_required, ticket.org_id, user.org.id) && org_membership_ids.includes(ticket.helpdesk_id)) return true;
                const isInStateToApproveOrReject = ticket.milestones && ticket.milestones.find((milestone) => [MilestoneSubStatus.SIGN_OFF_REQUESTED].includes(milestone.milestone_status)) && ticket.status !== TicketStatus.CLOSED;
                const canRejectAgents = ticket.agents.find((agent) => {
                    return [TicketAgentRole.PSP, TicketAgentRole.CLUSTER, TicketAgentRole.SP].includes(agent.role) && user.user.id === agent.agent.id;
                })
                return isInStateToApproveOrReject && canRejectAgents && org_membership_ids.includes(ticket.helpdesk_id);
            }

            case customerApprovalTicketServiceRequest.key: {
                let check = ticket.helpdesk_id === ScogoID && ticket.org_id === user.org.id && ticket.is_customer_sign_off_required === true
                    && canApproveSignOffTicket(ticket.actions) && ![TicketStatus.CLOSED, TicketStatus.ON_HOLD].includes(ticket.status) && milestonesToCheck.find((milestone) => milestone.milestone_status === MilestoneSubStatus.SIGN_OFF_REQUESTED);
                return check;
            }

            case customerRejectionTicketServiceRequest.key: {
                let check = ticket.helpdesk_id === ScogoID && ticket.org_id === user.org.id && ticket.is_customer_sign_off_required === true
                    && canApproveSignOffTicket(ticket.actions) && ![TicketStatus.CLOSED, TicketStatus.ON_HOLD].includes(ticket.status) && milestonesToCheck.find((milestone) => milestone.milestone_status === MilestoneSubStatus.SIGN_OFF_REQUESTED);
                return check;
            }

            case deleteServiceRequestAction.key:    // Delete Service Request Action
                return eligibleForDeleteServiceRequestAction(ticket.status, ticket.actions);



            // Verify Pending
            case updateSignOffNotesOfServiceRequest.key:    // Update SignOff Notes
                return canEditTicket(ticket) && eligibleForUpdateSignOffNotesOfServiceRequest(ticket.milestones);


            case resumeServiceRequest.key:    // Resume Service Request
                return ticket.status === TicketStatus.ON_HOLD && canHoldOrResumeTicket(ticket) && eligibleForResumeServiceRequest(ticket.milestones, ticket.status);

            case holdServiceRequest.key:    // Hold Service Request
                return ticket.status !== TicketStatus.ON_HOLD && canHoldOrResumeTicket(ticket) && eligibleForHoldServiceRequest(ticket.milestones, ticket.status);

            case hardCloseServiceRequest.key:    // Hard Close Service Request
                return canEditTicket(ticket) && (ticket.helpdesk_id === user.org.id || ticket.is_customer_sign_off_required === true) && eligibleForHardCloseServiceRequest(ticket.milestones, ticket.status);

            case serviceRequestSiteComplete.key:    // Site Complete 
                return canEditTicket(ticket) && eligibleForSiteComplete(ticket.milestones, ticket.status);

            case assignTechSupportToServiceRequest.key:    // Assign Tech Support
                return canEditTicket(ticket) && isScogoMember && eligibleForAssignTechSupport(ticket.milestones, ticket.status);

            case unlockServiceRequestRaiseSignoffAction.key: {
                // If milestone status is less than sign off requested then unlock the Raise sign off
                const isAvailableForRaiseSignoff = ticket.milestones.find((milestone) => milestone.is_signoff_locked && isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SITE_COMPLETED));
                return canEditTicket(ticket) && isAvailableForRaiseSignoff && ticket.status !== TicketStatus.ON_HOLD;
            };

            case unlockServiceRequestRaiseSignoffApprovalAction.key: {
                // If milestone status is less than sign off approved and greater than Sign off requested then unlock the unlock sign off approval
                const isAvailableForRaiseSignoffApproval = ticket.milestones.find((milestone) => milestone.is_signoff_locked && isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED, MilestoneSubStatus.SIGN_OFF_REQUESTED));
                return canUnlockSignOff(user.actions) && isAvailableForRaiseSignoffApproval && ticket.status !== TicketStatus.ON_HOLD;
            };

            // Unlock Service Request Signoff
            case addMilestoneInServiceRequest.key:  // Add Milestone In Service Request
            case assignTicketOwnerShip.key: // Assign Ticket Owner Ship
            case editServiceRequest.key:    // Edit Service Request
            case cloneTicket.key:  // Clone Ticket
                return canEditTicket(ticket) && ticket.status !== TicketStatus.ON_HOLD;

            case customerApprovalRecievedServiceRequest.key: {
                const status = getTicketBillingStatus(ticket);
                return !ticket.invoice_id && (isCustomerBillingPending(ticket) || status === BillingStatus.SUBMITTED) && ticket.helpdesk_id === ScogoID && user.org.id === ScogoID;
            }

            case customerBillingSubmittedServiceRequest.key: {
                return !ticket.invoice_id && (isCustomerBillingPending(ticket) || getTicketBillingStatus(ticket) === BillingStatus.REJECTED) && ticket.helpdesk_id === ScogoID && user.org.id === ScogoID;
            }

            case customerBillingRejectedServiceRequest.key: {
                return !ticket.invoice_id && getTicketBillingStatus(ticket) === BillingStatus.SUBMITTED && ticket.helpdesk_id === ScogoID && user.org.id === ScogoID;
            }

            case revokeCustomerApprovalServiceRequest.key: {
                // An invoiced ticket can no longer have its billing approval taken back.
                return getTicketBillingStatus(ticket) === BillingStatus.RECEIVED && !ticket.invoice_id && ticket.helpdesk_id === ScogoID && user.org.id === ScogoID;
            }

            default:
                return true;
        }
    });
    return maxActions;
}



export const getNextExecutionDate = ({ milestones } = {}) => {
    if (!milestones) {
        return { date: '', label: '' }
    }
    let date = '';
    let label = 'Execution Date';
    const isSiteCompleted = milestones.every((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SITE_COMPLETED, MilestoneSubStatus.HARD_CLOSED));
    let execution_dates = [];
    let site_completed_dates = [];

    if (isSiteCompleted) {
        site_completed_dates = milestones.filter((milestone) => validateDateValue(milestone.closed_at));
        label = 'Site Completed On';
        date = site_completed_dates.length > 0
            ? site_completed_dates.reduce((latest, milestone) => {
                const currentDate = new Date(milestone.closed_at);
                return currentDate > latest ? currentDate : latest;
            }, new Date(site_completed_dates[0].closed_at))
            : '';
    } else {
        execution_dates = milestones
            .filter(milestone => milestone.execution_dates && milestone.execution_dates.length > 0)
            .flatMap(milestone => milestone.execution_dates
                .map(execDate => validateDateValue(execDate.date))
            )

        const greater_dates = execution_dates.filter(date => date >= validateDateValue(new Date()));
        if (greater_dates && greater_dates.length > 0) {
            label = 'Execution Date';
            date = greater_dates.reduce((earliest, currentDate) => {
                return currentDate < earliest ? currentDate : earliest;
            }, greater_dates[0])

        }
    }

    if (!date && execution_dates.length > 0) {
        label = 'Execution Date';
        date = execution_dates[0];
    }

    if (!date && site_completed_dates.length > 0) {
        label = 'Site Completed On';
        date = site_completed_dates[0];
    }

    return { date, label };
}

const bulkHoldServiceRequest = {
    key: 'bulk_hold_ticket',
    menuName: 'Bulk Hold Tickets',
    menuIcon: 'pause',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const formName = 'HoldForm';
        let ticketIds = [];
        let tickets = getSelectedTickets();
        tickets = tickets.filter((ticket) => {
            return true;
        });

        if (tickets.length > 0) {
            if (tickets.length === 0) {
                return dispatch(sendToastMessage({ message: 'Tickets Are Not Eligible For Assign', status: 'warning' }));
            }
            ticketIds = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }



        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Hold Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: isMobileView ? '35rem' : '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={tickets[0].org_id} category='HOLD' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {
                let p = { ticket_ids: ticketIds };
                if (processed_remark?.value) {
                    p.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        p.master_remark_id = processed_remark.value;
                    }
                }
                dispatch(bulkServiceRequestStateChange({
                    payload: p,
                    formName,
                    state: 'hold'
                }));
            }
        });
    },
    isDisabled: () => {
        return false;
    },
};

const bulkResumeServiceRequest = {
    key: 'bulk_resume_ticket',
    menuName: 'Bulk Resume Tickets',
    menuIcon: 'play_arrow',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const formName = 'HoldForm';
        let ticketIds = [];
        let tickets = getSelectedTickets();
        tickets = tickets.filter((ticket) => {
            return true;
        });
        if (tickets.length > 0) {
            if (tickets.length === 0) {
                return dispatch(sendToastMessage({ message: 'Tickets Are Not Eligible For Assign', status: 'warning' }));
            }
            ticketIds = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }

        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Resume Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={tickets[0].org_id} category='RESUME' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {
                let p = { ticket_ids: ticketIds };
                if (processed_remark?.value) {
                    p.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        p.master_remark_id = processed_remark.value;
                    }
                }
                dispatch(bulkServiceRequestStateChange({
                    payload: p,
                    formName,
                    state: 'resume'
                }));
            }
        });
    },
    isDisabled: () => {
        return false;
    },
};

const bulkEditExecutionDateOfServiceRequest = {
    key: 'bulk_edit_execution_date_of_service_request',
    menuName: 'Bulk Edit Execution Date',
    menuIcon: 'edit_calendar',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        let ticketIds = [];
        let heading = 'Bulk Edit Execution Date';
        let tickets = getSelectedTickets();
        let milestone_ids = [];
        tickets.forEach((ticket) => {

            if (ticket.status === TicketStatus.CLOSED) return;
            ticket.milestones.forEach((milestone) => {
                if (isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_ACCEPTED)) {
                    milestone_ids.push(milestone.id);
                }
            });
        });

        if (milestone_ids.length === 0) {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket or Select tickets is not eligible for execution date change', status: 'warning' }));
        }

        let org_id = tickets[0].org_id;

        return dispatch(
            openCustomModal({
                heading,
                modalWidth: '60rem',
                modalHeight: 'auto',
                selectedCount: ticketIds.length,
                modalComponent: <BulkEditExecutionDate milestone_ids={milestone_ids} org_id={org_id} />,
            })
        );
    },
    isDisabled: (ticket) => {
        return false;
    },
};

const bulkAssignTechSupportOfServiceRequest = {
    key: 'bulk_assign_tech_support_of_service_request',
    menuName: 'Bulk Assign Tech Support',
    menuIcon: 'support_agent',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        let ticketIds = [];
        let heading = 'Bulk Assign Tech Support';
        let tickets = getSelectedTickets();

        let milestones = [];
        tickets.forEach((ticket) => {
            if (ticket.status === TicketStatus.CLOSED) return;
            const filteredMilestones = ticket.milestones.filter(
                ({ milestone_status, type }) =>
                    milestone_status !== MilestoneSubStatus.HARD_CLOSED &&
                    (
                        type === MilestoneType.REMOTE_SUPPORT ||
                        type === MilestoneType.RMA ||
                        type === MilestoneType.FIELD
                    )
            );
            milestones.push(...filteredMilestones);
        });

        if (milestones.length === 0) {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket or Select tickets is not eligible for Tech Support', status: 'warning' }));
        }

        let org_id = tickets[0].helpdesk_id;

        return dispatch(
            openCustomModal({
                heading,
                modalWidth: '60rem',
                modalHeight: 'auto',
                selectedCount: ticketIds.length,
                modalComponent: <AssignTechSupport org_id={org_id} milestones={milestones} isBulk={true} />,
            })
        );
    },
    isDisabled: (ticket, { getSelectedTickets = () => { } } = {}) => {
        return false;
    },
};

const bulkCloneTicketOfServiceRequest = {
    key: 'bulk_clone_ticket_of_service_request',
    menuName: 'Bulk Clone Ticket',
    menuIcon: 'content_copy',
    iconColor: 'text-scogobgsky',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const formName = 'bulkCloneTicket';
        let ticket_ids = [];
        let tickets = getSelectedTickets();
        if (tickets.length > 0) {
            ticket_ids = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }

        return dispatch(
            openTextModalAction({
                heading: 'Bulk Clone',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                selectedCount: ticket_ids.length,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        onClick: () => {
                            dispatch(bulkCloneServiceRequest({ formName, payload: { ticket_ids } }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
    isDisabled: (_, { getSelectedTickets = () => { } } = {}) => {
        return false;
    },
};

const bulkDeleteTicketOfServiceRequest = {
    key: 'bulk_delete_ticket_of_service_request',
    menuName: 'Delete Tickets',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        let formName = 'deleteTickets';
        let heading = 'Delete Tickets';
        let text = `Are you sure you want to Delete Tickets?`;
        let ticket_ids = [];
        let tickets = getSelectedTickets();
        tickets = tickets.filter((ticket) => {
            return true
        });
        if (tickets.length > 0) {
            ticket_ids = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(bulkDeleteServiceRequest({ formName, payload: { ticket_ids } })),
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        let closeOnBackdropClick = false;

        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName, selectedCount: ticket_ids.length }));
    },
};
export const bulkRemoveAgent = {
    key: 'remove_agents',
    menuName: 'Bulk Remove Cluster & PSP',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        let formName = 'removeAgent';
        let heading = 'Bulk Remove Cluster & PSP';
        let text = `Are you sure you want to remove cluster and PSP ?`;
        let ticket_ids = [];
        let tickets = getSelectedTickets();
        tickets = tickets.filter((ticket) => {
            return true
        });
        if (tickets.length > 0) {
            ticket_ids = tickets.map((ticket) => {
                return ticket.id;
            });
        } else {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => dispatch(removeBulkAgent({ formName, ticket_ids, roles: ['CLUSTER', 'PSP'], })),
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                onClick: () => dispatch(closeModalAction()),
            },
        ];
        let closeOnBackdropClick = false;

        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName, selectedCount: ticket_ids.length }));
    },

};


const bulkAssignAgentOfServiceRequest = {
    key: 'bulk_assign_agent_of_service_request',
    menuName: 'Bulk Assign',
    menuIcon: 'support_agent',
    iconColor: 'text-scogoorange',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        let ticketIds = [];
        let heading = 'Bulk Assign';
        let tickets = getSelectedTickets();

        if (tickets.length === 0) {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        }

        tickets = tickets.filter((ticket) => eligibleForAssign(ticket));

        let milestones = [];
        tickets.forEach((ticket) => {
            if (ticket.status === TicketStatus.CLOSED) return;
            ticket.milestones.forEach((milestone) => {
                if (isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.ENGINEER_AT_SITE)) {
                    milestones.push(milestone);
                }
            });
        });

        if (milestones.length === 0) {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket or Select tickets is not eligible for Assign', status: 'warning' }));
        }

        let org_id = tickets[0].org_id;

        return dispatch(
            openCustomModal({
                heading,
                modalWidth: '70rem',
                modalHeight: 'auto',
                selectedCount: ticketIds.length,
                modalComponent: <Assign org_id={org_id} milestones={milestones} isBulk={true} ticket={tickets[0]} />,
            })
        );
    },
    isDisabled: (ticket, { getSelectedTickets = () => { } } = {}) => {
        return false;
    },
};


const bulkUploadOfflineTransfer = {
    key: 'bulk_upload_offline_transaction',
    menuName: 'Bulk Upload Offline Transaction',
    menuIcon: 'upload',
    iconColor: 'text-scogobgsky',
    onClick: (_, dispatch, { } = {}) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Upload Offline Transaction',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'LOG_TICKET_OFFLINE_PAYMENTS'} />,
            })
        );
    },
};

// Keep bulk actions in step with the single-ticket billing transitions.
const getEligibleBillingApprovalTickets = (getSelectedTickets, dispatch, statusIsEligible) => {
    const tickets = getSelectedTickets() || [];

    if (tickets.length === 0) {
        dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        return null;
    }

    const eligibleTickets = tickets.filter((ticket) => !ticket.invoice_id && statusIsEligible(ticket));
    if (eligibleTickets.length === 0) {
        dispatch(sendToastMessage({ message: 'Selected tickets are not eligible to do this action.', status: 'warning' }));
        return null;
    }

    if (eligibleTickets.length > maxTicketsPerBillingApproval) {
        dispatch(sendToastMessage({ message: `At most ${maxTicketsPerBillingApproval} tickets can be processed at once`, status: 'warning' }));
        return null;
    }

    return eligibleTickets;
};

const bulkCustomerApprovalRecievedServiceRequest = {
    key: 'customer_approval_recieved',
    menuName: 'Bulk Customer Billing Received',
    menuIcon: 'receipt',
    iconColor: 'text-scogoprimary',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const tickets = getEligibleBillingApprovalTickets(getSelectedTickets, dispatch, (ticket) => isCustomerBillingPending(ticket) || getTicketBillingStatus(ticket) === BillingStatus.SUBMITTED);
        if (!tickets) return;

        let heading = <span className=''>
            Customer Billing Received :&nbsp;<span className='text-scogobgsky text-font16'>({tickets.length})</span>
        </span>;

        dispatch(openCustomModal({ modalComponent: <BillingApproval tickets={tickets} mode='received' />, heading, modalWidth: '70rem', modalHeight: 'auto', selectedCount: tickets.length }));
    }
};

const bulkCustomerBillingSubmittedServiceRequest = {
    key: 'bulk_customer_billing_submitted',
    menuName: 'Bulk Customer Billing Submitted',
    menuIcon: 'send',
    iconColor: 'text-scogoprimary',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const tickets = getEligibleBillingApprovalTickets(getSelectedTickets, dispatch, (ticket) => isCustomerBillingPending(ticket) || getTicketBillingStatus(ticket) === BillingStatus.REJECTED);
        if (!tickets) return;
        const heading = <span>Customer Billing Submitted :&nbsp;<span className='text-scogobgsky text-font16'>({tickets.length})</span></span>;
        dispatch(openCustomModal({ modalComponent: <BillingApproval tickets={tickets} mode='submitted' />, heading, modalWidth: '70rem', modalHeight: 'auto', selectedCount: tickets.length }));
    },
};

const bulkCustomerBillingRejectedServiceRequest = {
    key: 'bulk_customer_billing_rejected',
    menuName: 'Bulk Customer Billing Rejected',
    menuIcon: 'cancel',
    iconColor: 'text-scogoclosed',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const tickets = getEligibleBillingApprovalTickets(getSelectedTickets, dispatch, (ticket) => getTicketBillingStatus(ticket) === BillingStatus.SUBMITTED);
        if (!tickets) return;
        const heading = <span>Customer Billing Rejected :&nbsp;<span className='text-scogobgsky text-font16'>({tickets.length})</span></span>;
        dispatch(openCustomModal({ modalComponent: <BillingApproval tickets={tickets} mode='rejected' />, heading, modalWidth: '70rem', modalHeight: 'auto', selectedCount: tickets.length }));
    },
};

const bulkRevokeCustomerApprovalServiceRequest = {
    key: 'revoke_customer_approval',
    menuName: 'Bulk Revoke Customer Approval',
    menuIcon: 'undo',
    iconColor: 'text-scogoclosed',
    onClick: (_, dispatch, { getSelectedTickets } = {}) => {
        const tickets = getEligibleBillingApprovalTickets(getSelectedTickets, dispatch, (ticket) => getTicketBillingStatus(ticket) === BillingStatus.RECEIVED);
        if (!tickets) return;

        let heading = <span className=''>
            Revoke Customer Approval :&nbsp;<span className='text-scogobgsky text-font16'>({tickets.length})</span>
        </span>;

        dispatch(openCustomModal({ modalComponent: <RevokeBillingApproval tickets={tickets} />, heading, modalWidth: '70rem', modalHeight: 'auto', selectedCount: tickets.length }));
    }
};

const bulkUpdateServiceRequestDates = {
    key: 'bulk_update_service_request_dates',
    menuName: 'Update Ticket Dates',
    menuIcon: 'calendar_month',
    iconColor: 'text-scogobgsky',
    onClick: (_, dispatch, { } = {}) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Update Ticket Dates',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'EDIT_TICKET_AND_LEDGER_DATES'} />,
            })
        );
    },
};


const bulkSignoffUnlockAction = {
    key: 'bulk_signoff_unlock',
    menuName: 'Bulk Signoff Unlock',
    menuIcon: 'key',
    iconColor: 'text-scogoprimary',
    onClick: (_, dispatch, { getSelectedTickets, newLoggedUserData } = {}) => {
        let tickets = getSelectedTickets();

        if (tickets.length === 0) {
            return dispatch(sendToastMessage({ message: 'Select Atleast One Ticket', status: 'warning' }));
        };
        let milestones = [];
        tickets.forEach((ticket) => {
            if (ticket.status === TicketStatus.CLOSED) return;
            ticket.milestones.forEach((milestone) => {
                if (milestone.is_signoff_locked === false) return;
                if (milestone.milestone_status === MilestoneSubStatus.HARD_CLOSED) return;
                if (isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SITE_COMPLETED) && canEditTicket(ticket) && ticket.status !== TicketStatus.ON_HOLD) {
                    milestones.push(milestone);
                } else if (isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED, MilestoneSubStatus.SIGN_OFF_REQUESTED) && canUnlockSignOff(newLoggedUserData.actions)) {
                    milestones.push(milestone);
                }
            });
        });
        if (milestones.length === 0) {
            return dispatch(sendToastMessage({ message: 'Select tickets is not eligible for Signoff Unlock', status: 'warning' }));
        }
        let heading = (
            <span className='text-black'>
                Bulk Signoff Unlock :&nbsp;<span className='text-scogobgsky text-font16'>{milestones.length}</span>
            </span>
        );
        let modalComponent = <UnlockSignoff milestones={milestones} isBulk={true} />;
        let modalHeight = 'auto',
            modalWidth = '40rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    },
};

export const getBulkAction = ({ permissions, newLoggedUserData }) => {

    let maxActions = [
        bulkUploadSite,
        bulkAssetConfigCreation,
        bulkHoldServiceRequest,
        bulkResumeServiceRequest,
        bulkEditExecutionDateOfServiceRequest,
        bulkAssignAgentOfServiceRequest,
        bulkAssignTechSupportOfServiceRequest,
        bulkCloneTicketOfServiceRequest,
        bulkDeleteTicketOfServiceRequest,
        bulkUploadOfflineTransfer,
        bulkRemoveAgent,
        bulkCustomerBillingSubmittedServiceRequest,
        bulkCustomerApprovalRecievedServiceRequest,
        bulkCustomerBillingRejectedServiceRequest,
        bulkRevokeCustomerApprovalServiceRequest,
        bulkUpdateServiceRequestDates,
        bulkSignoffUnlockAction
    ];

    maxActions = maxActions.filter(({ key }) => {

        switch (key) {

            case bulkUpdateServiceRequestDates.key:
            case bulkUploadSite.key:
            case bulkAssetConfigCreation.key: {
                return isCreateTicketAllowed(newLoggedUserData.actions);
            }
            case bulkUploadOfflineTransfer.key: {
                return canLogOfflineTransactions(newLoggedUserData.actions);
            }

            case bulkHoldServiceRequest.key: {
                return permissions.includes(TicketActionsEnum.EDIT_TICKET);
            }

            case bulkResumeServiceRequest.key: {
                return permissions.includes(TicketActionsEnum.EDIT_TICKET);
            }

            case bulkUpdateServiceRequestDates.key:
            case bulkEditExecutionDateOfServiceRequest.key: {
                return permissions.includes(TicketActionsEnum.MODIFY_EXECUTION_DATE);
            }

            case bulkAssignAgentOfServiceRequest.key: {
                return permissions.includes(TicketActionsEnum.ASSIGN_TICKET);
            }

            case bulkAssignTechSupportOfServiceRequest.key: {
                return permissions.includes(TicketActionsEnum.EDIT_TICKET);
            }

            case bulkCloneTicketOfServiceRequest.key: {
                return permissions.includes(TicketActionsEnum.EDIT_TICKET);
            }

            case bulkDeleteTicketOfServiceRequest.key: {
                return permissions.includes(TicketActionsEnum.DELETE_TICKET);
            }

            case bulkRemoveAgent.key: {
                return canBulkRemoveCluster(newLoggedUserData.actions);
            }

            case bulkCustomerApprovalRecievedServiceRequest.key:
            case bulkCustomerBillingSubmittedServiceRequest.key:
            case bulkCustomerBillingRejectedServiceRequest.key:
            case bulkRevokeCustomerApprovalServiceRequest.key: {
                return newLoggedUserData.org.id === ScogoID;
            }

            case bulkSignoffUnlockAction.key: {
                return permissions.includes(TicketActionsEnum.EDIT_TICKET);
            }

            default:
                return true;
        }
    });
    return maxActions;
};


export const TicketSource = {
    IVR: "IVR"
}

export const RegionsType = {
    STATE: 'STATE',
    CITY: 'CITY',
    DISTRICT: 'DISTRICT',
    LOCALITY: 'LOCALITY',
    REGION_TIER: 'REGION_TIER'
}
